/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  Account_BigInt: { input: number; output: number; }
  /** A location in a connection that can be used for resuming pagination. */
  Account_Cursor: { input: string; output: string; }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Account_Datetime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  Account_JSON: { input: unknown; output: unknown; }
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: { input: any; output: any; }
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: { input: string; output: string; }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: string; output: string; }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: unknown; output: unknown; }
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: { input: string; output: string; }
};

/** Account holding keys and plan. */
export type Account_Account = Account_Node & {
  __typename?: 'Account_Account';
  /** Reads a single `Bot` that is related to this `Account`. */
  bot?: Maybe<Account_Bot>;
  /**
   * Reads and enables pagination through a set of `Bot`.
   * @deprecated Please use bot instead
   */
  bots: Account_BotsConnection;
  /** @deprecated Useless field, always true */
  canSelect?: Maybe<Scalars['Boolean']['output']>;
  canUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** The time when the account was created. */
  createdAt: Scalars['Account_Datetime']['output'];
  /** Reads a single `Key` that is related to this `Account`. */
  encryptionKey?: Maybe<Account_Key>;
  encryptionKeyId?: Maybe<Scalars['Account_BigInt']['output']>;
  /** Get the underlying entity object (User,Team or Organization) as a Node interface. */
  entity?: Maybe<Account_Node>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Key`. */
  keys: Account_KeysConnection;
  /** The members of an account. */
  members: Account_MembersConnection;
  /**
   * The members of an account that are not a part of the provided entity. This can
   * be useful for getting the members of an organization that are not part of a specific team.
   */
  membersOutsideEntity: Account_MembersConnection;
  /** Reads a single `Organization` that is related to this `Account`. */
  organization?: Maybe<Account_Organization>;
  /**
   * Reads and enables pagination through a set of `Organization`.
   * @deprecated Please use organization instead
   */
  organizations: Account_OrganizationsConnection;
  /** The id of the account. */
  rowId: Scalars['Account_BigInt']['output'];
  /** Reads a single `Key` that is related to this `Account`. */
  signingKey?: Maybe<Account_Key>;
  signingKeyId?: Maybe<Scalars['Account_BigInt']['output']>;
  /** Reads a single `Team` that is related to this `Account`. */
  team?: Maybe<Account_Team>;
  /**
   * Reads and enables pagination through a set of `Team`.
   * @deprecated Please use team instead
   */
  teams: Account_TeamsConnection;
  /** The time when the account was last updated. */
  updatedAt: Scalars['Account_Datetime']['output'];
  /** Reads a single `User` that is related to this `Account`. */
  user?: Maybe<Account_User>;
  /**
   * Reads and enables pagination through a set of `User`.
   * @deprecated Please use user instead
   */
  users: Account_UsersConnection;
};


/** Account holding keys and plan. */
export type Account_AccountBotsArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  condition?: InputMaybe<Account_BotCondition>;
  filter?: InputMaybe<Account_BotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Account_BotsOrderBy>>;
};


/** Account holding keys and plan. */
export type Account_AccountKeysArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  condition?: InputMaybe<Account_KeyCondition>;
  filter?: InputMaybe<Account_KeyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Account_KeysOrderBy>>;
};


/** Account holding keys and plan. */
export type Account_AccountMembersArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  filter?: InputMaybe<Account_MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Account holding keys and plan. */
export type Account_AccountMembersOutsideEntityArgs = {
  accountRowId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  filter?: InputMaybe<Account_MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Account holding keys and plan. */
export type Account_AccountOrganizationsArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  condition?: InputMaybe<Account_OrganizationCondition>;
  filter?: InputMaybe<Account_OrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Account_OrganizationsOrderBy>>;
};


/** Account holding keys and plan. */
export type Account_AccountTeamsArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  condition?: InputMaybe<Account_TeamCondition>;
  filter?: InputMaybe<Account_TeamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Account_TeamsOrderBy>>;
};


/** Account holding keys and plan. */
export type Account_AccountUsersArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  condition?: InputMaybe<Account_UserCondition>;
  filter?: InputMaybe<Account_UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Account_UsersOrderBy>>;
};

/** A condition to be used against `Account` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type Account_AccountCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Checks for equality with the object’s `encryptionKeyId` field. */
  encryptionKeyId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Checks for equality with the object’s `signingKeyId` field. */
  signingKeyId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Account_Datetime']['input']>;
};

/** A filter to be used against `Account` object types. All fields are combined with a logical ‘and.’ */
export type Account_AccountFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<Account_AccountFilter>>;
  /** Filter by the object’s `canSelect` field. */
  canSelect?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `canUpdate` field. */
  canUpdate?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<Account_DatetimeFilter>;
  /** Filter by the object’s `encryptionKeyId` field. */
  encryptionKeyId?: InputMaybe<Account_BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<Account_AccountFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<Account_AccountFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<Account_BigIntFilter>;
  /** Filter by the object’s `signingKeyId` field. */
  signingKeyId?: InputMaybe<Account_BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Account_DatetimeFilter>;
};

/** A connection to a list of `Account` values. */
export type Account_AccountsConnection = {
  __typename?: 'Account_AccountsConnection';
  /** A list of edges which contains the `Account` and cursor to aid in pagination. */
  edges: Array<Account_AccountsEdge>;
  /** A list of `Account` objects. */
  nodes: Array<Maybe<Account_Account>>;
  /** Information to aid in pagination. */
  pageInfo: Account_PageInfo;
  /** The count of *all* `Account` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Account` edge in the connection. */
export type Account_AccountsEdge = {
  __typename?: 'Account_AccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Account_Cursor']['output']>;
  /** The `Account` at the end of the edge. */
  node?: Maybe<Account_Account>;
};

/** Methods to use when ordering `Account`. */
export enum Account_AccountsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EncryptionKeyIdAsc = 'ENCRYPTION_KEY_ID_ASC',
  EncryptionKeyIdDesc = 'ENCRYPTION_KEY_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SigningKeyIdAsc = 'SIGNING_KEY_ID_ASC',
  SigningKeyIdDesc = 'SIGNING_KEY_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type Account_BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Account_BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Account_BigInt']['input']>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type Account_BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** A bot account used for third-party applications */
export type Account_Bot = Account_Node & {
  __typename?: 'Account_Bot';
  /** Reads a single `Account` that is related to this `Bot`. */
  account?: Maybe<Account_Account>;
  accountId: Scalars['Account_BigInt']['output'];
  /** Bot logo */
  avatar?: Maybe<Scalars['String']['output']>;
  canUpdate?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Account_Datetime']['output'];
  /** The date of deletion of the bot, if it has been removed from its organization */
  deletedAt?: Maybe<Scalars['Account_Datetime']['output']>;
  /** Bot description */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Bot name */
  name: Scalars['String']['output'];
  organization?: Maybe<Account_Organization>;
  /** Bot parent organization */
  organizationId: Scalars['Account_BigInt']['output'];
  /** The ID of the bot */
  rowId: Scalars['Account_BigInt']['output'];
  /** Reads and enables pagination through a set of `Team`. */
  teams: Account_TeamsConnection;
  updatedAt: Scalars['Account_Datetime']['output'];
};


/** A bot account used for third-party applications */
export type Account_BotTeamsArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  filter?: InputMaybe<Account_TeamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A condition to be used against `Bot` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type Account_BotCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Checks for equality with the object’s `avatar` field. */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Account_Datetime']['input']>;
};

/** A filter to be used against `Bot` object types. All fields are combined with a logical ‘and.’ */
export type Account_BotFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<Account_BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<Account_BotFilter>>;
  /** Filter by the object’s `avatar` field. */
  avatar?: InputMaybe<Account_StringFilter>;
  /** Filter by the object’s `canUpdate` field. */
  canUpdate?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<Account_DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<Account_StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<Account_StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<Account_BotFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<Account_BotFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<Account_BigIntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<Account_BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Account_DatetimeFilter>;
};

/** A connection to a list of `Bot` values. */
export type Account_BotsConnection = {
  __typename?: 'Account_BotsConnection';
  /** A list of edges which contains the `Bot` and cursor to aid in pagination. */
  edges: Array<Account_BotsEdge>;
  /** A list of `Bot` objects. */
  nodes: Array<Maybe<Account_Bot>>;
  /** Information to aid in pagination. */
  pageInfo: Account_PageInfo;
  /** The count of *all* `Bot` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Bot` edge in the connection. */
export type Account_BotsEdge = {
  __typename?: 'Account_BotsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Account_Cursor']['output']>;
  /** The `Bot` at the end of the edge. */
  node?: Maybe<Account_Bot>;
};

/** Methods to use when ordering `Bot`. */
export enum Account_BotsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AvatarAsc = 'AVATAR_ASC',
  AvatarDesc = 'AVATAR_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type Account_DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Account_Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Account_Datetime']['input']>>;
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type Account_IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Account_IsSuperuser = Account_Node & {
  __typename?: 'Account_IsSuperuser';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  isSuperuser?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `User` that is related to this `IsSuperuser`. */
  row?: Maybe<Account_User>;
  rowId: Scalars['Account_BigInt']['output'];
};

/**
 * A condition to be used against `IsSuperuser` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type Account_IsSuperuserCondition = {
  /** Checks for equality with the object’s `isSuperuser` field. */
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Account_BigInt']['input']>;
};

/** A filter to be used against `IsSuperuser` object types. All fields are combined with a logical ‘and.’ */
export type Account_IsSuperuserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<Account_IsSuperuserFilter>>;
  /** Filter by the object’s `isSuperuser` field. */
  isSuperuser?: InputMaybe<Account_BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<Account_IsSuperuserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<Account_IsSuperuserFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<Account_BigIntFilter>;
};

/** A connection to a list of `IsSuperuser` values. */
export type Account_IsSuperusersConnection = {
  __typename?: 'Account_IsSuperusersConnection';
  /** A list of edges which contains the `IsSuperuser` and cursor to aid in pagination. */
  edges: Array<Account_IsSuperusersEdge>;
  /** A list of `IsSuperuser` objects. */
  nodes: Array<Maybe<Account_IsSuperuser>>;
  /** Information to aid in pagination. */
  pageInfo: Account_PageInfo;
  /** The count of *all* `IsSuperuser` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `IsSuperuser` edge in the connection. */
export type Account_IsSuperusersEdge = {
  __typename?: 'Account_IsSuperusersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Account_Cursor']['output']>;
  /** The `IsSuperuser` at the end of the edge. */
  node?: Maybe<Account_IsSuperuser>;
};

/** Methods to use when ordering `IsSuperuser`. */
export enum Account_IsSuperusersOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsSuperuserAsc = 'IS_SUPERUSER_ASC',
  IsSuperuserDesc = 'IS_SUPERUSER_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type Account_JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['Account_JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['Account_JSON']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Account_JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Account_JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Account_JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Account_JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Account_JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Account_JSON']['input']>>;
};

/** A signing key. */
export type Account_Key = Account_Node & {
  __typename?: 'Account_Key';
  /** Reads a single `Account` that is related to this `Key`. */
  account?: Maybe<Account_Account>;
  /** Reads and enables pagination through a set of `Account`. */
  accountForActiveEncryptionKey: Account_AccountsConnection;
  /** Reads and enables pagination through a set of `Account`. */
  accountForActiveSigningKey: Account_AccountsConnection;
  /** The account id the key is linked to */
  accountId: Scalars['Account_BigInt']['output'];
  /** @deprecated Useless field, always true */
  canSelect?: Maybe<Scalars['Boolean']['output']>;
  canUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** The time when the key was created. */
  createdAt: Scalars['Account_Datetime']['output'];
  /** Has the key been deprecated */
  deprecated: Scalars['Boolean']['output'];
  /** The time when the key was deprecated */
  deprecatedAt?: Maybe<Scalars['Account_Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `PrivateKey` that is related to this `Key`. */
  privateKey?: Maybe<Account_PrivateKey>;
  /** PEM encoded public key */
  publicKey: Scalars['String']['output'];
  /** The id of the key. */
  rowId: Scalars['Account_BigInt']['output'];
  /** The time when the key was last updated. */
  updatedAt: Scalars['Account_Datetime']['output'];
  /** Key usage type */
  usage: Account_KeyUsage;
};


/** A signing key. */
export type Account_KeyAccountForActiveEncryptionKeyArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  condition?: InputMaybe<Account_AccountCondition>;
  filter?: InputMaybe<Account_AccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Account_AccountsOrderBy>>;
};


/** A signing key. */
export type Account_KeyAccountForActiveSigningKeyArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  condition?: InputMaybe<Account_AccountCondition>;
  filter?: InputMaybe<Account_AccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Account_AccountsOrderBy>>;
};

/** A condition to be used against `Key` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type Account_KeyCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Checks for equality with the object’s `deprecated` field. */
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `deprecatedAt` field. */
  deprecatedAt?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Checks for equality with the object’s `publicKey` field. */
  publicKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Checks for equality with the object’s `usage` field. */
  usage?: InputMaybe<Account_KeyUsage>;
};

/** A filter to be used against `Key` object types. All fields are combined with a logical ‘and.’ */
export type Account_KeyFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<Account_BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<Account_KeyFilter>>;
  /** Filter by the object’s `canSelect` field. */
  canSelect?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `canUpdate` field. */
  canUpdate?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<Account_DatetimeFilter>;
  /** Filter by the object’s `deprecated` field. */
  deprecated?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `deprecatedAt` field. */
  deprecatedAt?: InputMaybe<Account_DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<Account_KeyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<Account_KeyFilter>>;
  /** Filter by the object’s `publicKey` field. */
  publicKey?: InputMaybe<Account_StringFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<Account_BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Account_DatetimeFilter>;
  /** Filter by the object’s `usage` field. */
  usage?: InputMaybe<Account_KeyUsageFilter>;
};

export enum Account_KeyUsage {
  Encrypt = 'ENCRYPT',
  Sign = 'SIGN'
}

/** A filter to be used against KeyUsage fields. All fields are combined with a logical ‘and.’ */
export type Account_KeyUsageFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Account_KeyUsage>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Account_KeyUsage>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Account_KeyUsage>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Account_KeyUsage>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Account_KeyUsage>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Account_KeyUsage>>;
};

/** A connection to a list of `Key` values. */
export type Account_KeysConnection = {
  __typename?: 'Account_KeysConnection';
  /** A list of edges which contains the `Key` and cursor to aid in pagination. */
  edges: Array<Account_KeysEdge>;
  /** A list of `Key` objects. */
  nodes: Array<Maybe<Account_Key>>;
  /** Information to aid in pagination. */
  pageInfo: Account_PageInfo;
  /** The count of *all* `Key` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Key` edge in the connection. */
export type Account_KeysEdge = {
  __typename?: 'Account_KeysEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Account_Cursor']['output']>;
  /** The `Key` at the end of the edge. */
  node?: Maybe<Account_Key>;
};

/** Methods to use when ordering `Key`. */
export enum Account_KeysOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeprecatedAsc = 'DEPRECATED_ASC',
  DeprecatedAtAsc = 'DEPRECATED_AT_ASC',
  DeprecatedAtDesc = 'DEPRECATED_AT_DESC',
  DeprecatedDesc = 'DEPRECATED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PublicKeyAsc = 'PUBLIC_KEY_ASC',
  PublicKeyDesc = 'PUBLIC_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UsageAsc = 'USAGE_ASC',
  UsageDesc = 'USAGE_DESC'
}

/**  An account member. */
export type Account_Member = {
  __typename?: 'Account_Member';
  /** The id of the account. */
  accountId?: Maybe<Scalars['Account_BigInt']['output']>;
  /** Is the user an admin of the account. */
  admin?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the user is a collaborator (i.e. external to the organization) */
  collaborator?: Maybe<Scalars['Boolean']['output']>;
  /** The email address of the user. */
  email?: Maybe<Scalars['String']['output']>;
  /** Is the user a workflow leader. (organization-level only!) */
  leader?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the user. */
  name?: Maybe<Scalars['String']['output']>;
  /** Is the user a reader of the account. */
  reader?: Maybe<Scalars['Boolean']['output']>;
  /** The user entity behind the member. */
  user?: Maybe<Account_User>;
  /** The id of the user. */
  userId?: Maybe<Scalars['Account_BigInt']['output']>;
};

/** A filter to be used against `Member` object types. All fields are combined with a logical ‘and.’ */
export type Account_MemberFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<Account_BigIntFilter>;
  /** Filter by the object’s `admin` field. */
  admin?: InputMaybe<Account_BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<Account_MemberFilter>>;
  /** Filter by the object’s `collaborator` field. */
  collaborator?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<Account_StringFilter>;
  /** Filter by the object’s `leader` field. */
  leader?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<Account_StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<Account_MemberFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<Account_MemberFilter>>;
  /** Filter by the object’s `reader` field. */
  reader?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<Account_BigIntFilter>;
};

/** A connection to a list of `Member` values. */
export type Account_MembersConnection = {
  __typename?: 'Account_MembersConnection';
  /** A list of edges which contains the `Member` and cursor to aid in pagination. */
  edges: Array<Account_MembersEdge>;
  /** A list of `Member` objects. */
  nodes: Array<Maybe<Account_Member>>;
  /** Information to aid in pagination. */
  pageInfo: Account_PageInfo;
  /** The count of *all* `Member` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Member` edge in the connection. */
export type Account_MembersEdge = {
  __typename?: 'Account_MembersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Account_Cursor']['output']>;
  /** The `Member` at the end of the edge. */
  node?: Maybe<Account_Member>;
};

/** An object with a globally unique `ID`. */
export type Account_Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
};

/** An organization */
export type Account_Organization = Account_Node & {
  __typename?: 'Account_Organization';
  /** Reads a single `Account` that is related to this `Organization`. */
  account?: Maybe<Account_Account>;
  /** Id of the account linked to the organization */
  accountId: Scalars['Account_BigInt']['output'];
  /** Organization logo */
  avatar?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Bot`. */
  bots: Account_BotsConnection;
  /** @deprecated Useless field, always true */
  canInsert?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Useless field, always true */
  canSelect?: Maybe<Scalars['Boolean']['output']>;
  canUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** Returns a list of `User`s who are collaborators of the `Organization`. */
  collaborators: Account_UsersConnection;
  /** The time when the team was created. */
  createdAt: Scalars['Account_Datetime']['output'];
  /** Organization description */
  description: Scalars['String']['output'];
  /** Official domain name for the organization */
  domainName?: Maybe<Scalars['String']['output']>;
  /** The amount of purchased group administrator licenses for an organization. */
  groupAdministratorLicenses?: Maybe<Scalars['Int']['output']>;
  /** The amount of group administrator licenses left for an organization. */
  groupAdministratorLicensesLeft?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  isLeader?: Maybe<Scalars['Boolean']['output']>;
  /** The members of an organization. */
  members: Account_MembersConnection;
  /** Organization official name */
  name: Scalars['String']['output'];
  /** The amount of purchased organization owner licenses for an organization. */
  organizationOwnerLicenses?: Maybe<Scalars['Int']['output']>;
  /** The amount of organization owner licenses left for an organization. */
  organizationOwnerLicensesLeft?: Maybe<Scalars['Int']['output']>;
  /** The list of auth providers allowed for a user to signup when invited in this organization. */
  providers?: Maybe<Array<Maybe<Account_Provider>>>;
  /** The id of the organization */
  rowId: Scalars['Account_BigInt']['output'];
  /** The amount of purchased seats for an organization. */
  seats?: Maybe<Scalars['Int']['output']>;
  /** The amount of seats left for an organization. */
  seatsLeft?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `Team`. */
  teams: Account_TeamsConnection;
  /** The time when the team was last updated. */
  updatedAt: Scalars['Account_Datetime']['output'];
};


/** An organization */
export type Account_OrganizationBotsArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  filter?: InputMaybe<Account_BotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** An organization */
export type Account_OrganizationCollaboratorsArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  filter?: InputMaybe<Account_UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** An organization */
export type Account_OrganizationMembersArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  filter?: InputMaybe<Account_MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** An organization */
export type Account_OrganizationTeamsArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  condition?: InputMaybe<Account_TeamCondition>;
  filter?: InputMaybe<Account_TeamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Account_TeamsOrderBy>>;
};

/**
 * A condition to be used against `Organization` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type Account_OrganizationCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Checks for equality with the object’s `avatar` field. */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `domainName` field. */
  domainName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `groupAdministratorLicenses` field. */
  groupAdministratorLicenses?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationOwnerLicenses` field. */
  organizationOwnerLicenses?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `providers` field. */
  providers?: InputMaybe<Array<InputMaybe<Account_Provider>>>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Checks for equality with the object’s `seats` field. */
  seats?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Account_Datetime']['input']>;
};

/** A filter to be used against `Organization` object types. All fields are combined with a logical ‘and.’ */
export type Account_OrganizationFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<Account_BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<Account_OrganizationFilter>>;
  /** Filter by the object’s `avatar` field. */
  avatar?: InputMaybe<Account_StringFilter>;
  /** Filter by the object’s `canInsert` field. */
  canInsert?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `canSelect` field. */
  canSelect?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `canUpdate` field. */
  canUpdate?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<Account_DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<Account_StringFilter>;
  /** Filter by the object’s `domainName` field. */
  domainName?: InputMaybe<Account_StringFilter>;
  /** Filter by the object’s `groupAdministratorLicenses` field. */
  groupAdministratorLicenses?: InputMaybe<Account_IntFilter>;
  /** Filter by the object’s `groupAdministratorLicensesLeft` field. */
  groupAdministratorLicensesLeft?: InputMaybe<Account_IntFilter>;
  /** Filter by the object’s `isLeader` field. */
  isLeader?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<Account_StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<Account_OrganizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<Account_OrganizationFilter>>;
  /** Filter by the object’s `organizationOwnerLicenses` field. */
  organizationOwnerLicenses?: InputMaybe<Account_IntFilter>;
  /** Filter by the object’s `organizationOwnerLicensesLeft` field. */
  organizationOwnerLicensesLeft?: InputMaybe<Account_IntFilter>;
  /** Filter by the object’s `providers` field. */
  providers?: InputMaybe<Account_ProviderListFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<Account_BigIntFilter>;
  /** Filter by the object’s `seats` field. */
  seats?: InputMaybe<Account_IntFilter>;
  /** Filter by the object’s `seatsLeft` field. */
  seatsLeft?: InputMaybe<Account_IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Account_DatetimeFilter>;
};

/** A connection to a list of `Organization` values. */
export type Account_OrganizationsConnection = {
  __typename?: 'Account_OrganizationsConnection';
  /** A list of edges which contains the `Organization` and cursor to aid in pagination. */
  edges: Array<Account_OrganizationsEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<Account_Organization>>;
  /** Information to aid in pagination. */
  pageInfo: Account_PageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Organization` edge in the connection. */
export type Account_OrganizationsEdge = {
  __typename?: 'Account_OrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Account_Cursor']['output']>;
  /** The `Organization` at the end of the edge. */
  node?: Maybe<Account_Organization>;
};

/** Methods to use when ordering `Organization`. */
export enum Account_OrganizationsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AvatarAsc = 'AVATAR_ASC',
  AvatarDesc = 'AVATAR_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DomainNameAsc = 'DOMAIN_NAME_ASC',
  DomainNameDesc = 'DOMAIN_NAME_DESC',
  GroupAdministratorLicensesAsc = 'GROUP_ADMINISTRATOR_LICENSES_ASC',
  GroupAdministratorLicensesDesc = 'GROUP_ADMINISTRATOR_LICENSES_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrganizationOwnerLicensesAsc = 'ORGANIZATION_OWNER_LICENSES_ASC',
  OrganizationOwnerLicensesDesc = 'ORGANIZATION_OWNER_LICENSES_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProvidersAsc = 'PROVIDERS_ASC',
  ProvidersDesc = 'PROVIDERS_DESC',
  SeatsAsc = 'SEATS_ASC',
  SeatsDesc = 'SEATS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Information about pagination in a connection. */
export type Account_PageInfo = {
  __typename?: 'Account_PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Account_Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Account_Cursor']['output']>;
};

/** A signing key. */
export type Account_PrivateKey = Account_Node & {
  __typename?: 'Account_PrivateKey';
  /** @deprecated Useless field, always true */
  canSelect?: Maybe<Scalars['Boolean']['output']>;
  canUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** Decrypted PEM encoded private key */
  decrypted?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  owner?: Maybe<Account_Account>;
  /** Is private key password protected. */
  passwordProtected: Scalars['Boolean']['output'];
  /** PEM encoded private key. */
  privateKey: Scalars['String']['output'];
  /** Reads a single `Key` that is related to this `PrivateKey`. */
  public?: Maybe<Account_Key>;
  publicKeyId: Scalars['Account_BigInt']['output'];
  /** The id of the private key. */
  rowId: Scalars['Account_BigInt']['output'];
};

export enum Account_Provider {
  Cnp = 'CNP',
  Cognito = 'COGNITO',
  Google = 'GOOGLE',
  Keycloak = 'KEYCLOAK',
  MicrosoftSiaPartners = 'MICROSOFT_SIA_PARTNERS',
  OneAccountAxa = 'ONE_ACCOUNT_AXA',
  PassAxa = 'PASS_AXA',
  Stratumn = 'STRATUMN'
}

/** A filter to be used against Provider List fields. All fields are combined with a logical ‘and.’ */
export type Account_ProviderListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Account_Provider>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Account_Provider>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Account_Provider>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Account_Provider>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Account_Provider>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Account_Provider>>>;
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type Account_StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /**
   * Matches the specified pattern (case-sensitive). An underscore (_) matches any
   * single character; a percent sign (%) matches any sequence of zero or more characters.
   */
  like?: InputMaybe<Scalars['String']['input']>;
  /**
   * Matches the specified pattern (case-insensitive). An underscore (_) matches
   * any single character; a percent sign (%) matches any sequence of zero or more characters.
   */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /**
   * Does not match the specified pattern (case-sensitive). An underscore (_)
   * matches any single character; a percent sign (%) matches any sequence of zero
   * or more characters.
   */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /**
   * Does not match the specified pattern (case-insensitive). An underscore (_)
   * matches any single character; a percent sign (%) matches any sequence of zero
   * or more characters.
   */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern using the SQL standard's definition of a regular expression. */
  notSimilarTo?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern using the SQL standard's definition of a regular expression. */
  similarTo?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

/** An organization */
export type Account_Team = Account_Node & {
  __typename?: 'Account_Team';
  /** Reads a single `Account` that is related to this `Team`. */
  account?: Maybe<Account_Account>;
  accountId: Scalars['Account_BigInt']['output'];
  /** Team logo */
  avatar?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Bot`. */
  bots: Account_BotsConnection;
  /** @deprecated Useless field, always true */
  canInsert?: Maybe<Scalars['Boolean']['output']>;
  canUpdate?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Account_Datetime']['output'];
  /** Team description */
  description: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** The members of an team. */
  members: Account_MembersConnection;
  /** Team name */
  name: Scalars['String']['output'];
  /** Reads a single `Organization` that is related to this `Team`. */
  organization?: Maybe<Account_Organization>;
  /** Team parent organization */
  organizationId: Scalars['Account_BigInt']['output'];
  /** The id og the team */
  rowId: Scalars['Account_BigInt']['output'];
  updatedAt: Scalars['Account_Datetime']['output'];
};


/** An organization */
export type Account_TeamBotsArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  filter?: InputMaybe<Account_BotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** An organization */
export type Account_TeamMembersArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  filter?: InputMaybe<Account_MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A condition to be used against `Team` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type Account_TeamCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Checks for equality with the object’s `avatar` field. */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Account_Datetime']['input']>;
};

/** A filter to be used against `Team` object types. All fields are combined with a logical ‘and.’ */
export type Account_TeamFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<Account_BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<Account_TeamFilter>>;
  /** Filter by the object’s `avatar` field. */
  avatar?: InputMaybe<Account_StringFilter>;
  /** Filter by the object’s `canInsert` field. */
  canInsert?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `canUpdate` field. */
  canUpdate?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<Account_DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<Account_StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<Account_StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<Account_StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<Account_TeamFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<Account_TeamFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<Account_BigIntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<Account_BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Account_DatetimeFilter>;
};

/** A connection to a list of `Team` values. */
export type Account_TeamsConnection = {
  __typename?: 'Account_TeamsConnection';
  /** A list of edges which contains the `Team` and cursor to aid in pagination. */
  edges: Array<Account_TeamsEdge>;
  /** A list of `Team` objects. */
  nodes: Array<Maybe<Account_Team>>;
  /** Information to aid in pagination. */
  pageInfo: Account_PageInfo;
  /** The count of *all* `Team` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Team` edge in the connection. */
export type Account_TeamsEdge = {
  __typename?: 'Account_TeamsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Account_Cursor']['output']>;
  /** The `Team` at the end of the edge. */
  node?: Maybe<Account_Team>;
};

/** Methods to use when ordering `Team`. */
export enum Account_TeamsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AvatarAsc = 'AVATAR_ASC',
  AvatarDesc = 'AVATAR_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A user */
export type Account_User = Account_Node & {
  __typename?: 'Account_User';
  /** Reads a single `Account` that is related to this `User`. */
  account?: Maybe<Account_Account>;
  /** The id of the account linked to the user */
  accountId: Scalars['Account_BigInt']['output'];
  /** List of OAuth providers that the user can choose from on the signup page (if empty, all providers are allowed) */
  allowedProviders?: Maybe<Array<Maybe<Account_Provider>>>;
  /** User profile picture */
  avatar?: Maybe<Scalars['String']['output']>;
  /** @deprecated Useless field, always true */
  canInsert?: Maybe<Scalars['Boolean']['output']>;
  canUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** The time when the user was created. */
  createdAt: Scalars['Account_Datetime']['output'];
  /** User email */
  email: Scalars['String']['output'];
  /** The first name of the user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Indicates if the invite token has expired */
  inviteExpired: Scalars['Boolean']['output'];
  /** Whether user has superuser access rights. */
  isSuperuser?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `IsSuperuser` that is related to this `User`. */
  isSuperuserByRowId?: Maybe<Account_IsSuperuser>;
  /**
   * Reads and enables pagination through a set of `IsSuperuser`.
   * @deprecated Please use isSuperuserByRowId instead
   */
  isSuperusersByRowId: Account_IsSuperusersConnection;
  /** The last name of the user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The accounts to which the user participates. */
  memberOf: Account_AccountsConnection;
  /** The first name and last name concatenated together. */
  name: Scalars['String']['output'];
  notificationPreference: Scalars['Account_JSON']['output'];
  /** The organizations to which the user belongs. */
  organizations: Account_OrganizationsConnection;
  pending?: Maybe<Scalars['Boolean']['output']>;
  /** User phone number */
  phone?: Maybe<Scalars['String']['output']>;
  /** The id of the user */
  rowId: Scalars['Account_BigInt']['output'];
  /** The teams to which the user belongs. */
  teams: Account_TeamsConnection;
  /** The time when the user was last updated. */
  updatedAt: Scalars['Account_Datetime']['output'];
};


/** A user */
export type Account_UserIsSuperusersByRowIdArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  condition?: InputMaybe<Account_IsSuperuserCondition>;
  filter?: InputMaybe<Account_IsSuperuserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Account_IsSuperusersOrderBy>>;
};


/** A user */
export type Account_UserMemberOfArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  filter?: InputMaybe<Account_AccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A user */
export type Account_UserOrganizationsArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  filter?: InputMaybe<Account_OrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A user */
export type Account_UserTeamsArgs = {
  after?: InputMaybe<Scalars['Account_Cursor']['input']>;
  before?: InputMaybe<Scalars['Account_Cursor']['input']>;
  filter?: InputMaybe<Account_TeamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type Account_UserCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Checks for equality with the object’s `allowedProviders` field. */
  allowedProviders?: InputMaybe<Array<InputMaybe<Account_Provider>>>;
  /** Checks for equality with the object’s `avatar` field. */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Account_Datetime']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `isSuperuser` field. */
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `notificationPreference` field. */
  notificationPreference?: InputMaybe<Scalars['Account_JSON']['input']>;
  /** Checks for equality with the object’s `pending` field. */
  pending?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `phone` field. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Account_BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Account_Datetime']['input']>;
};

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type Account_UserFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<Account_BigIntFilter>;
  /** Filter by the object’s `allowedProviders` field. */
  allowedProviders?: InputMaybe<Account_ProviderListFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<Account_UserFilter>>;
  /** Filter by the object’s `avatar` field. */
  avatar?: InputMaybe<Account_StringFilter>;
  /** Filter by the object’s `canInsert` field. */
  canInsert?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `canUpdate` field. */
  canUpdate?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<Account_DatetimeFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<Account_StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<Account_StringFilter>;
  /** Filter by the object’s `isSuperuser` field. */
  isSuperuser?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<Account_StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<Account_StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<Account_UserFilter>;
  /** Filter by the object’s `notificationPreference` field. */
  notificationPreference?: InputMaybe<Account_JsonFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<Account_UserFilter>>;
  /** Filter by the object’s `pending` field. */
  pending?: InputMaybe<Account_BooleanFilter>;
  /** Filter by the object’s `phone` field. */
  phone?: InputMaybe<Account_StringFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<Account_BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Account_DatetimeFilter>;
};

/** A connection to a list of `User` values. */
export type Account_UsersConnection = {
  __typename?: 'Account_UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<Account_UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<Account_User>>;
  /** Information to aid in pagination. */
  pageInfo: Account_PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection. */
export type Account_UsersEdge = {
  __typename?: 'Account_UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Account_Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node?: Maybe<Account_User>;
};

/** Methods to use when ordering `User`. */
export enum Account_UsersOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AllowedProvidersAsc = 'ALLOWED_PROVIDERS_ASC',
  AllowedProvidersDesc = 'ALLOWED_PROVIDERS_DESC',
  AvatarAsc = 'AVATAR_ASC',
  AvatarDesc = 'AVATAR_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsSuperuserAsc = 'IS_SUPERUSER_ASC',
  IsSuperuserDesc = 'IS_SUPERUSER_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  NotificationPreferenceAsc = 'NOTIFICATION_PREFERENCE_ASC',
  NotificationPreferenceDesc = 'NOTIFICATION_PREFERENCE_DESC',
  PendingAsc = 'PENDING_ASC',
  PendingDesc = 'PENDING_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type Action = {
  __typename?: 'Action';
  answerableComments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  canBeGrouped?: Maybe<Scalars['Boolean']['output']>;
  /** Is the current user allowed to use this action */
  canUse?: Maybe<Scalars['Boolean']['output']>;
  dataEditor?: Maybe<Scalars['JSON']['output']>;
  dataImporter?: Maybe<Scalars['JSON']['output']>;
  definitions?: Maybe<Scalars['JSON']['output']>;
  /** The description of the action */
  description?: Maybe<Scalars['String']['output']>;
  /** The effects performed by the action */
  effects?: Maybe<Scalars['JSON']['output']>;
  /** The form associated to the action */
  form?: Maybe<ActionForm>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** The icon attached to the action */
  icon?: Maybe<Scalars['String']['output']>;
  /** The identifier of the action */
  key: Scalars['String']['output'];
  /** The name of the stage of the action */
  stageName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** A filter to be used against `Action` object types. All fields are combined with a logical ‘and.’ */
export type ActionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ActionFilter>>;
  /** Filter by the object’s `answerableComments` field. */
  answerableComments?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `canBeGrouped` field. */
  canBeGrouped?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `canUse` field. */
  canUse?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dataEditor` field. */
  dataEditor?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `dataImporter` field. */
  dataImporter?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `definitions` field. */
  definitions?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `effects` field. */
  effects?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `form` field. */
  form?: InputMaybe<ActionFormFilter>;
  /** Filter by the object’s `hidden` field. */
  hidden?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `icon` field. */
  icon?: InputMaybe<StringFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ActionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ActionFilter>>;
  /** Filter by the object’s `stageName` field. */
  stageName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
};

/** The form associated to an action */
export type ActionForm = {
  __typename?: 'ActionForm';
  /** The JSON schema of the form */
  schema?: Maybe<Scalars['JSON']['output']>;
  /** The UI schema of the form */
  uiSchema?: Maybe<Scalars['JSON']['output']>;
};

/** A filter to be used against `ActionForm` object types. All fields are combined with a logical ‘and.’ */
export type ActionFormFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ActionFormFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<ActionFormFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ActionFormFilter>>;
  /** Filter by the object’s `schema` field. */
  schema?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `uiSchema` field. */
  uiSchema?: InputMaybe<JsonFilter>;
};

/** A connection to a list of `Action` values. */
export type ActionsConnection = {
  __typename?: 'ActionsConnection';
  /** A list of edges which contains the `Action` and cursor to aid in pagination. */
  edges: Array<ActionsEdge>;
  /** A list of `Action` objects. */
  nodes: Array<Maybe<Action>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Action` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Action` edge in the connection. */
export type ActionsEdge = {
  __typename?: 'ActionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Action` at the end of the edge. */
  node?: Maybe<Action>;
};

export type AddEvidenceInput = {
  /** The evidence data */
  data: Scalars['JSON']['input'];
  /** The link hash of the evidence */
  link_hash: Scalars['String']['input'];
  /** The evidence provider */
  provider: Scalars['String']['input'];
};

export type AddEvidencePayload = {
  __typename?: 'AddEvidencePayload';
  addedEvidence?: Maybe<Scalars['BigInt']['output']>;
};

/** All input for the `addTagsToTrace` mutation. */
export type AddTagsToTraceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  traceRowId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `addTagsToTrace` mutation. */
export type AddTagsToTracePayload = {
  __typename?: 'AddTagsToTracePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  trace?: Maybe<Trace>;
  /** An edge for our `Trace`. May be used by Relay 1. */
  traceEdge?: Maybe<TracesEdge>;
  /** Reads a single `Workflow` that is related to this `Trace`. */
  workflow?: Maybe<Workflow>;
};


/** The output of our `addTagsToTrace` mutation. */
export type AddTagsToTracePayloadTraceEdgeArgs = {
  orderBy?: InputMaybe<Array<TracesOrderBy>>;
};

/** All input for the `assignActionToGroup` mutation. */
export type AssignActionToGroupInput = {
  actionKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `assignActionToGroup` mutation. */
export type AssignActionToGroupPayload = {
  __typename?: 'AssignActionToGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workflow` that is related to this `Group`. */
  workflow?: Maybe<Workflow>;
};


/** The output of our `assignActionToGroup` mutation. */
export type AssignActionToGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

export enum AttestationType {
  Free = 'FREE',
  Owned = 'OWNED'
}

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** A filter to be used against BigInt List fields. All fields are combined with a logical ‘and.’ */
export type BigIntListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** All input for the `createGroup` mutation. */
export type CreateGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<GroupInputRecordInput>;
};

/** The output of our `createGroup` mutation. */
export type CreateGroupPayload = {
  __typename?: 'CreateGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workflow` that is related to this `Group`. */
  workflow?: Maybe<Workflow>;
};


/** The output of our `createGroup` mutation. */
export type CreateGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

export type CreateLinkInput = {
  /** The data associated with the link */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** The link to be created */
  link: Scalars['JSON']['input'];
  /** Nofication object to send custom notifications */
  notify?: InputMaybe<NotificationsInput>;
  /** A list of account IDs to be notified by the link creation */
  notifyAccountIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type CreateLinkPayload = {
  __typename?: 'CreateLinkPayload';
  query?: Maybe<Query>;
  stages: Array<Stage>;
  trace: Trace;
};

/** Reponse of the create links mutation */
export type CreateLinksPayload = {
  __typename?: 'CreateLinksPayload';
  /** The links that have been created */
  links?: Maybe<Array<Link>>;
};

/** All input for the create `NotificationSubscription` mutation. */
export type CreateNotificationSubscriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `NotificationSubscription` to be created by this mutation. */
  notificationSubscription: NotificationSubscriptionInput;
};

/** The output of our create `NotificationSubscription` mutation. */
export type CreateNotificationSubscriptionPayload = {
  __typename?: 'CreateNotificationSubscriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `NotificationSubscription` that was created by this mutation. */
  notificationSubscription?: Maybe<NotificationSubscription>;
  /** An edge for our `NotificationSubscription`. May be used by Relay 1. */
  notificationSubscriptionEdge?: Maybe<NotificationSubscriptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workflow` that is related to this `NotificationSubscription`. */
  workflow?: Maybe<Workflow>;
};


/** The output of our create `NotificationSubscription` mutation. */
export type CreateNotificationSubscriptionPayloadNotificationSubscriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationSubscriptionsOrderBy>>;
};

/** All input for the `createWorkflow` mutation. */
export type CreateWorkflowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workflow?: InputMaybe<WorkflowInputRecordInput>;
};

/** The output of our `createWorkflow` mutation. */
export type CreateWorkflowPayload = {
  __typename?: 'CreateWorkflowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  workflow?: Maybe<Workflow>;
  /** An edge for our `Workflow`. May be used by Relay 1. */
  workflowEdge?: Maybe<WorkflowsEdge>;
};


/** The output of our `createWorkflow` mutation. */
export type CreateWorkflowPayloadWorkflowEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowsOrderBy>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

/** All input for the `deleteNotificationSubscriptionByUserIdAndWorkflowIdAndActionkey` mutation. */
export type DeleteNotificationSubscriptionByUserIdAndWorkflowIdAndActionkeyInput = {
  actionkey: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['BigInt']['input'];
  workflowId: Scalars['BigInt']['input'];
};

/** All input for the `deleteNotificationSubscription` mutation. */
export type DeleteNotificationSubscriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `NotificationSubscription` to be deleted. */
  id: Scalars['ID']['input'];
};

/** The output of our delete `NotificationSubscription` mutation. */
export type DeleteNotificationSubscriptionPayload = {
  __typename?: 'DeleteNotificationSubscriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedNotificationSubscriptionId?: Maybe<Scalars['ID']['output']>;
  /** The `NotificationSubscription` that was deleted by this mutation. */
  notificationSubscription?: Maybe<NotificationSubscription>;
  /** An edge for our `NotificationSubscription`. May be used by Relay 1. */
  notificationSubscriptionEdge?: Maybe<NotificationSubscriptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workflow` that is related to this `NotificationSubscription`. */
  workflow?: Maybe<Workflow>;
};


/** The output of our delete `NotificationSubscription` mutation. */
export type DeleteNotificationSubscriptionPayloadNotificationSubscriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationSubscriptionsOrderBy>>;
};

export type DeleteWorkflowInput = {
  /** The ID of the workflow to be deleted */
  workflowRowId: Scalars['BigInt']['input'];
};

export type DeleteWorkflowPayload = {
  __typename?: 'DeleteWorkflowPayload';
  deletedWorkflowRowId?: Maybe<Scalars['BigInt']['output']>;
};

/** The documentation for the workflow. */
export type Documentation = {
  __typename?: 'Documentation';
  /** Object representing the documentation as a file. */
  file?: Maybe<File>;
  /** The url of the documentation. */
  url?: Maybe<Scalars['String']['output']>;
};

/** A filter to be used against `Documentation` object types. All fields are combined with a logical ‘and.’ */
export type DocumentationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentationFilter>>;
  /** Filter by the object’s `file` field. */
  file?: InputMaybe<FileFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentationFilter>>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Documentation` */
export type DocumentationInput = {
  /** Object representing the documentation as a file. */
  file?: InputMaybe<FileInput>;
  /** The url of the documentation. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the `editGroupMembership` mutation. */
export type EditGroupMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  grantOrRevoke?: InputMaybe<EditMembershipActionType>;
  groupId?: InputMaybe<Scalars['BigInt']['input']>;
  memberId?: InputMaybe<Scalars['BigInt']['input']>;
  role?: InputMaybe<RoleType>;
};

/** The output of our `editGroupMembership` mutation. */
export type EditGroupMembershipPayload = {
  __typename?: 'EditGroupMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workflow` that is related to this `Group`. */
  workflow?: Maybe<Workflow>;
};


/** The output of our `editGroupMembership` mutation. */
export type EditGroupMembershipPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** The type of action that can be done on a membership. */
export enum EditMembershipActionType {
  Grant = 'GRANT',
  Revoke = 'REVOKE'
}

/** All input for the `editWorkflowMembership` mutation. */
export type EditWorkflowMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  grantOrRevoke?: InputMaybe<EditMembershipActionType>;
  memberId?: InputMaybe<Scalars['BigInt']['input']>;
  role?: InputMaybe<RoleType>;
  workflowId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `editWorkflowMembership` mutation. */
export type EditWorkflowMembershipPayload = {
  __typename?: 'EditWorkflowMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  workflow?: Maybe<Workflow>;
  /** An edge for our `Workflow`. May be used by Relay 1. */
  workflowEdge?: Maybe<WorkflowsEdge>;
};


/** The output of our `editWorkflowMembership` mutation. */
export type EditWorkflowMembershipPayloadWorkflowEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowsOrderBy>>;
};

/**
 * Evidences can be used to externally verify a link's existence at a given
 * moment in time.
 * An evidence can be a proof of inclusion in a public blockchain, a timestamp
 * signed by a trusted authority or anything that you trust to provide an immutable
 * ordering of your process' steps.
 */
export type Evidence = Node & {
  __typename?: 'Evidence';
  /** The evidence backend. */
  backend?: Maybe<Scalars['JSON']['output']>;
  /** The time at which the evidence was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The evidence data. */
  data: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  linkHash?: Maybe<Scalars['String']['output']>;
  /** The evidence proof. */
  proof?: Maybe<Scalars['JSON']['output']>;
  /** Provider of the evidence. e.g. bitcoin testnet. */
  provider: Scalars['String']['output'];
  /** The time at which the evidence was last updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** A filter to be used against `Evidence` object types. All fields are combined with a logical ‘and.’ */
export type EvidenceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EvidenceFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `data` field. */
  data?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EvidenceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EvidenceFilter>>;
  /** Filter by the object’s `provider` field. */
  provider?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `Evidence` values. */
export type EvidencesConnection = {
  __typename?: 'EvidencesConnection';
  /** A list of edges which contains the `Evidence` and cursor to aid in pagination. */
  edges: Array<EvidencesEdge>;
  /** A list of `Evidence` objects. */
  nodes: Array<Maybe<Evidence>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Evidence` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Evidence` edge in the connection. */
export type EvidencesEdge = {
  __typename?: 'EvidencesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Evidence` at the end of the edge. */
  node?: Maybe<Evidence>;
};

/** A file object. */
export type File = {
  __typename?: 'File';
  /** The digest of the file. */
  digest?: Maybe<Scalars['String']['output']>;
  /** The name of the file. */
  name?: Maybe<Scalars['JSON']['output']>;
  /** Size of file in bytes. */
  size?: Maybe<Scalars['JSON']['output']>;
};

/** A filter to be used against `File` object types. All fields are combined with a logical ‘and.’ */
export type FileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FileFilter>>;
  /** Filter by the object’s `digest` field. */
  digest?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FileFilter>>;
};

/** An input for mutations affecting `File` */
export type FileInput = {
  /** The digest of the file. */
  digest?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type FloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type Form = {
  __typename?: 'Form';
  /** Denotes whether or not this is the active version of the form. */
  active?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Is the current user allowed to use this form.
   * @deprecated Use actions instead
   */
  canUse?: Maybe<Scalars['Boolean']['output']>;
  /** The time when the form was created. */
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** The description of the form. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Groups which can use this form.
   * @deprecated Use action.groups instead
   */
  groups: GroupsConnection;
  /** The icon attached to the form. */
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The identifier shared across all versions of a form. */
  identifier?: Maybe<Scalars['BigInt']['output']>;
  /** Flags if the form has been used at least once. */
  isUsed?: Maybe<Scalars['Boolean']['output']>;
  /** The id of the form. */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** The JSON schema of the form. */
  schema?: Maybe<Scalars['JSON']['output']>;
  /** The name of the stage of the form. */
  stageName?: Maybe<Scalars['String']['output']>;
  /** The title of the form. */
  title?: Maybe<Scalars['String']['output']>;
  /** The UI schema of the form. */
  uiSchema?: Maybe<Scalars['JSON']['output']>;
  /** The time when the form was last updated. */
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** The version number of the form. */
  version?: Maybe<Scalars['BigInt']['output']>;
  /**
   * The workflow of the form.
   * @deprecated Use action.workflow instead
   */
  workflow?: Maybe<Workflow>;
  /** The id of the workflow the form belongs to. */
  workflowId?: Maybe<Scalars['BigInt']['output']>;
};


export type FormGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `Form` object types. All fields are combined with a logical ‘and.’ */
export type FormFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FormFilter>>;
  /** Filter by the object’s `canUse` field. */
  canUse?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `icon` field. */
  icon?: InputMaybe<StringFilter>;
  /** Filter by the object’s `identifier` field. */
  identifier?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isUsed` field. */
  isUsed?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FormFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FormFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `schema` field. */
  schema?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `stageName` field. */
  stageName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `uiSchema` field. */
  uiSchema?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `workflowId` field. */
  workflowId?: InputMaybe<BigIntFilter>;
};

/** A connection to a list of `Form` values. */
export type FormsConnection = {
  __typename?: 'FormsConnection';
  /** A list of edges which contains the `Form` and cursor to aid in pagination. */
  edges: Array<FormsEdge>;
  /** A list of `Form` objects. */
  nodes: Array<Maybe<Form>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Form` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Form` edge in the connection. */
export type FormsEdge = {
  __typename?: 'FormsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Form` at the end of the edge. */
  node?: Maybe<Form>;
};

/** A Trace group. */
export type Group = Node & {
  __typename?: 'Group';
  /** Actions usable for this group */
  actions: ActionsConnection;
  /** Avatar of the group */
  avatar?: Maybe<Scalars['String']['output']>;
  /** Can the current user perform an action for this group */
  canAct?: Maybe<Scalars['Boolean']['output']>;
  canActQuick?: Maybe<Scalars['Boolean']['output']>;
  /** Is the current user allowed to update this group. */
  canUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** The time when the group was created. */
  createdAt: Scalars['Datetime']['output'];
  /**
   * Forms usable for this group.
   * @deprecated Use group.actions instead
   */
  forms: FormsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** The group label. */
  label: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Link`. */
  links: LinksConnection;
  /** Reads and enables pagination through a set of `GroupMember`. */
  members: GroupMembersConnection;
  /** Name of the group */
  name: Scalars['String']['output'];
  /**
   * The owner of the group.
   * @deprecated Ownership is getting deprecated, use group.members instead
   */
  owner?: Maybe<Account_Account>;
  /** @deprecated Ownership is getting deprecated, use group.members instead */
  ownerId?: Maybe<Scalars['BigInt']['output']>;
  /** The id of the group. */
  rowId: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `Stage`. */
  stages: StagesConnection;
  /** The time when the group was last updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `Workflow` that is related to this `Group`. */
  workflow?: Maybe<Workflow>;
  /** The id of the workflow the group belongs to. */
  workflowId: Scalars['BigInt']['output'];
};


/** A Trace group. */
export type GroupActionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ActionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A Trace group. */
export type GroupFormsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FormFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A Trace group. */
export type GroupLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LinkCondition>;
  filter?: InputMaybe<LinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LinksOrderBy>>;
};


/** A Trace group. */
export type GroupMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GroupMemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A Trace group. */
export type GroupStagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StageCondition>;
  filter?: InputMaybe<StageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StagesOrderBy>>;
};

/** A condition to be used against `Group` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GroupCondition = {
  /** Checks for equality with the object’s `avatar` field. */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `workflowId` field. */
  workflowId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `Group` object types. All fields are combined with a logical ‘and.’ */
export type GroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GroupFilter>>;
  /** Filter by the object’s `avatar` field. */
  avatar?: InputMaybe<StringFilter>;
  /** Filter by the object’s `canAct` field. */
  canAct?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `canUpdate` field. */
  canUpdate?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GroupFilter>>;
  /** Filter by the object’s `ownerId` field. */
  ownerId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `workflowId` field. */
  workflowId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `GroupInputRecord` */
export type GroupInputRecordInput = {
  /** The group avatar. */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** The group label. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The group name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The Account ID of the organization or group that owns the group. */
  ownerId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The ID of the workflow the group belongs to. */
  workflowId?: InputMaybe<Scalars['BigInt']['input']>;
};

export type GroupMember = {
  __typename?: 'GroupMember';
  /** The account of the member entity. */
  account?: Maybe<Account_Account>;
  /** Account id in Stratumn account. */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Is the member an admin. */
  admin?: Maybe<Scalars['Boolean']['output']>;
  /** Is the member a reader. */
  reader?: Maybe<Scalars['Boolean']['output']>;
};

/** A filter to be used against `GroupMember` object types. All fields are combined with a logical ‘and.’ */
export type GroupMemberFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `admin` field. */
  admin?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GroupMemberFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<GroupMemberFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GroupMemberFilter>>;
  /** Filter by the object’s `reader` field. */
  reader?: InputMaybe<BooleanFilter>;
};

/** A connection to a list of `GroupMember` values. */
export type GroupMembersConnection = {
  __typename?: 'GroupMembersConnection';
  /** A list of edges which contains the `GroupMember` and cursor to aid in pagination. */
  edges: Array<GroupMembersEdge>;
  /** A list of `GroupMember` objects. */
  nodes: Array<Maybe<GroupMember>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GroupMember` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `GroupMember` edge in the connection. */
export type GroupMembersEdge = {
  __typename?: 'GroupMembersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `GroupMember` at the end of the edge. */
  node?: Maybe<GroupMember>;
};

/** Represents an update to a `Group`. Fields that are set will be updated. */
export type GroupPatch = {
  /** Avatar of the group */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Name of the group */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Group of traces indexed by a value of their state. */
export type GroupedTrace = {
  __typename?: 'GroupedTrace';
  id: Scalars['ID']['output'];
  /** The state attribute common to this group of traces */
  index?: Maybe<Scalars['String']['output']>;
  /** The group of traces matching the index. */
  traces: TracesConnection;
};


/** Group of traces indexed by a value of their state. */
export type GroupedTraceTracesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  customFilter?: InputMaybe<TraceCustomFilter>;
  filter?: InputMaybe<TraceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `GroupedTrace` object types. All fields are combined with a logical ‘and.’ */
export type GroupedTraceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GroupedTraceFilter>>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GroupedTraceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GroupedTraceFilter>>;
};

/** Group of traces indexed by a value of their state. */
export type GroupedTraceState = {
  __typename?: 'GroupedTraceState';
  /** The state attribute common to this group of traces */
  index?: Maybe<Scalars['String']['output']>;
  /** The group of trace states matching the index. */
  traceStates: TraceStatesConnection;
};


/** Group of traces indexed by a value of their state. */
export type GroupedTraceStateTraceStatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TraceStateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TraceStatesOrderByPath>>;
};

/** A filter to be used against `GroupedTraceState` object types. All fields are combined with a logical ‘and.’ */
export type GroupedTraceStateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GroupedTraceStateFilter>>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GroupedTraceStateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GroupedTraceStateFilter>>;
};

/** A connection to a list of `GroupedTraceState` values. */
export type GroupedTraceStatesConnection = {
  __typename?: 'GroupedTraceStatesConnection';
  /** A list of edges which contains the `GroupedTraceState` and cursor to aid in pagination. */
  edges: Array<GroupedTraceStatesEdge>;
  /** A list of `GroupedTraceState` objects. */
  nodes: Array<Maybe<GroupedTraceState>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GroupedTraceState` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `GroupedTraceState` edge in the connection. */
export type GroupedTraceStatesEdge = {
  __typename?: 'GroupedTraceStatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `GroupedTraceState` at the end of the edge. */
  node?: Maybe<GroupedTraceState>;
};

/** A connection to a list of `GroupedTrace` values. */
export type GroupedTracesConnection = {
  __typename?: 'GroupedTracesConnection';
  /** A list of edges which contains the `GroupedTrace` and cursor to aid in pagination. */
  edges: Array<GroupedTracesEdge>;
  /** A list of `GroupedTrace` objects. */
  nodes: Array<Maybe<GroupedTrace>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GroupedTrace` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `GroupedTrace` edge in the connection. */
export type GroupedTracesEdge = {
  __typename?: 'GroupedTracesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `GroupedTrace` at the end of the edge. */
  node?: Maybe<GroupedTrace>;
};

/** A connection to a list of `Group` values. */
export type GroupsConnection = {
  __typename?: 'GroupsConnection';
  /** A list of edges which contains the `Group` and cursor to aid in pagination. */
  edges: Array<GroupsEdge>;
  /** A list of `Group` objects. */
  nodes: Array<Maybe<Group>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Group` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Group` edge in the connection. */
export type GroupsEdge = {
  __typename?: 'GroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Group` at the end of the edge. */
  node?: Maybe<Group>;
};

/** Methods to use when ordering `Group`. */
export enum GroupsOrderBy {
  AvatarAsc = 'AVATAR_ASC',
  AvatarDesc = 'AVATAR_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LabelAsc = 'LABEL_ASC',
  LabelDesc = 'LABEL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WorkflowIdAsc = 'WORKFLOW_ID_ASC',
  WorkflowIdDesc = 'WORKFLOW_ID_DESC'
}

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** All input for the `inviteUsersToGroup` mutation. */
export type InviteUsersToGroupInput = {
  emails: Array<InputMaybe<Scalars['String']['input']>>;
  groupRowId: Scalars['BigInt']['input'];
};

/** The output of our `inviteUsersToGroup` mutation. */
export type InviteUsersToGroupPayload = {
  __typename?: 'InviteUsersToGroupPayload';
  group?: Maybe<Group>;
};

/** Used to filter workflow traces states */
export type JsonDeepFilter = {
  format?: InputMaybe<Scalars['String']['input']>;
  inputFormat?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

/** A filter to be used against JSON List fields. All fields are combined with a logical ‘and.’ */
export type JsonListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

/** A Chainscript link. */
export type Link = Node & {
  __typename?: 'Link';
  /** The workflow action used by the link */
  action?: Maybe<Action>;
  /** The key of the workflow action used by the link */
  actionKey?: Maybe<Scalars['String']['output']>;
  /** Reads a single `WorkflowConfig` that is related to this `Link`. */
  config?: Maybe<WorkflowConfig>;
  /** The configuration with which the link has been created */
  configId?: Maybe<Scalars['BigInt']['output']>;
  /** The time at which the link was created. */
  createdAt: Scalars['Datetime']['output'];
  /** @deprecated Use createdByAccount instead */
  createdBy?: Maybe<Account_User>;
  createdByAccount?: Maybe<Account_Account>;
  /** The ID of the account used to create the link. */
  createdByAccountId?: Maybe<Scalars['BigInt']['output']>;
  /**
   * The ID of the user who created the link, if the link was created by a user.
   * @deprecated Use createdByAccountId instead
   */
  createdById: Scalars['BigInt']['output'];
  /**
   * The ID of the user who created the link, if the link was created by a user.
   * @deprecated Use createdByAccountId instead
   */
  createdByUserId?: Maybe<Scalars['BigInt']['output']>;
  /** The data in the link (link.data). */
  data?: Maybe<Scalars['JSON']['output']>;
  /** The list of evidences of a link. */
  evidences: EvidencesConnection;
  /**
   * The form used by the link
   * @deprecated true
   */
  form?: Maybe<Form>;
  formId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Group` that is related to this `Link`. */
  group?: Maybe<Group>;
  /** The group of the link (link.meta.data.groupId) */
  groupId: Scalars['BigInt']['output'];
  /** The height of the link (link.meta.priority). */
  height: Scalars['Float']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** The list of inputs used for this action (link.meta.data.inputs). */
  inputs?: Maybe<Array<Maybe<Scalars['BigInt']['output']>>>;
  /** The last form that was used to attest (link.meta.data.lastFormId). */
  lastFormId?: Maybe<Scalars['String']['output']>;
  /** The hash of the link. */
  linkHash?: Maybe<Scalars['String']['output']>;
  /**
   * The list of the groups to which the ownership can be transfered.
   * @deprecated Use workflow transitions instead
   */
  nextGroups: Array<Maybe<Group>>;
  /** The hash of the previous link. */
  prevLinkHash?: Maybe<Scalars['String']['output']>;
  /** The stage of the link (link.meta.process.state). */
  processState: ProcessState;
  /** The raw link data. */
  raw: Scalars['JSON']['output'];
  /** Links referencing this link */
  referencedBy: LinksConnection;
  /** Links this link references */
  references: LinksConnection;
  /** The list of tags of the link. */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  trace?: Maybe<Trace>;
  /** The id of the link's trace. */
  traceId: Scalars['String']['output'];
  /** The workflow of the link */
  workflow?: Maybe<Workflow>;
  /** The id of the link' workflow. */
  workflowId: Scalars['String']['output'];
};


/** A Chainscript link. */
export type LinkEvidencesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<EvidenceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A Chainscript link. */
export type LinkReferencedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<LinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A Chainscript link. */
export type LinkReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<LinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A condition to be used against `Link` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LinkCondition = {
  /** Checks for equality with the object’s `actionKey` field. */
  actionKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdByAccountId` field. */
  createdByAccountId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `height` field. */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `inputs` field. */
  inputs?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Checks for equality with the object’s `lastFormId` field. */
  lastFormId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `processState` field. */
  processState?: InputMaybe<ProcessState>;
  /** Checks for equality with the object’s `raw` field. */
  raw?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `traceId` field. */
  traceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `workflowId` field. */
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Link` object types. All fields are combined with a logical ‘and.’ */
export type LinkFilter = {
  /** Filter by the object’s `actionKey` field. */
  actionKey?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LinkFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdByAccountId` field. */
  createdByAccountId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdById` field. */
  createdById?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `formId` field. */
  formId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `height` field. */
  height?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `inputs` field. */
  inputs?: InputMaybe<BigIntListFilter>;
  /** Filter by the object’s `lastFormId` field. */
  lastFormId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `linkHash` field. */
  linkHash?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LinkFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LinkFilter>>;
  /** Filter by the object’s `prevLinkHash` field. */
  prevLinkHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `processState` field. */
  processState?: InputMaybe<ProcessStateFilter>;
  /** Filter by the object’s `raw` field. */
  raw?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `tags` field. */
  tags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `traceId` field. */
  traceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `workflowId` field. */
  workflowId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `Link` values. */
export type LinksConnection = {
  __typename?: 'LinksConnection';
  /** A list of edges which contains the `Link` and cursor to aid in pagination. */
  edges: Array<LinksEdge>;
  /** A list of `Link` objects. */
  nodes: Array<Maybe<Link>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Link` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Link` edge in the connection. */
export type LinksEdge = {
  __typename?: 'LinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Link` at the end of the edge. */
  node?: Maybe<Link>;
};

/** Methods to use when ordering `Link`. */
export enum LinksOrderBy {
  ActionKeyAsc = 'ACTION_KEY_ASC',
  ActionKeyDesc = 'ACTION_KEY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAccountIdAsc = 'CREATED_BY_ACCOUNT_ID_ASC',
  CreatedByAccountIdDesc = 'CREATED_BY_ACCOUNT_ID_DESC',
  CreatedByUserIdAsc = 'CREATED_BY_USER_ID_ASC',
  CreatedByUserIdDesc = 'CREATED_BY_USER_ID_DESC',
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  HeightAsc = 'HEIGHT_ASC',
  HeightDesc = 'HEIGHT_DESC',
  InputsAsc = 'INPUTS_ASC',
  InputsDesc = 'INPUTS_DESC',
  LastFormIdAsc = 'LAST_FORM_ID_ASC',
  LastFormIdDesc = 'LAST_FORM_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProcessStateAsc = 'PROCESS_STATE_ASC',
  ProcessStateDesc = 'PROCESS_STATE_DESC',
  RawAsc = 'RAW_ASC',
  RawDesc = 'RAW_DESC',
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  TraceIdAsc = 'TRACE_ID_ASC',
  TraceIdDesc = 'TRACE_ID_DESC',
  WorkflowIdAsc = 'WORKFLOW_ID_ASC',
  WorkflowIdDesc = 'WORKFLOW_ID_DESC'
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  addEvidence?: Maybe<AddEvidencePayload>;
  /** Adds multiple tags to a trace. */
  addTagsToTrace?: Maybe<AddTagsToTracePayload>;
  /** Assign a workflow action to a group */
  assignActionToGroup?: Maybe<AssignActionToGroupPayload>;
  /** Creates a single `Group` */
  createGroup?: Maybe<CreateGroupPayload>;
  createLink?: Maybe<CreateLinkPayload>;
  createLinks?: Maybe<CreateLinksPayload>;
  /** Creates a single `NotificationSubscription`. */
  createNotificationSubscription?: Maybe<CreateNotificationSubscriptionPayload>;
  /** Creates a single `Workflow` */
  createWorkflow?: Maybe<CreateWorkflowPayload>;
  /** Deletes a single `NotificationSubscription` using its globally unique id. */
  deleteNotificationSubscription?: Maybe<DeleteNotificationSubscriptionPayload>;
  /** Deletes a single `NotificationSubscription` using a unique key. */
  deleteNotificationSubscriptionByUserIdAndWorkflowIdAndActionkey?: Maybe<DeleteNotificationSubscriptionPayload>;
  deleteWorkflow?: Maybe<DeleteWorkflowPayload>;
  /**
   * To edit the memberships of a group.
   * @deprecated Please use updateGroupMembers instead
   */
  editGroupMembership?: Maybe<EditGroupMembershipPayload>;
  /** To edit the memberships of a workflow. */
  editWorkflowMembership?: Maybe<EditWorkflowMembershipPayload>;
  /**
   * Add users to specified group, throught their email addresses. If needed, we
   * will create a new Account & invite customer to claim it.
   */
  inviteUsersToGroup?: Maybe<InviteUsersToGroupPayload>;
  /**
   * Creates a new configuration for a workflow and deprecates the previous one (if any).
   * Note: if a key is omitted, function will use last known value.
   * @deprecated To update a worflow, please use updateWorkflowDetails instead. This function is a private implementation and should not be use directly.
   */
  newWorkflowConfig?: Maybe<NewWorkflowConfigPayload>;
  /** Removes multiple tags from a trace. */
  removeTagsFromTrace?: Maybe<RemoveTagsFromTracePayload>;
  /** Updates a single `Group` using its globally unique id and a patch. */
  updateGroup?: Maybe<UpdateGroupPayload>;
  /** Updates a single `Group` using a unique key and a patch. */
  updateGroupByRowId?: Maybe<UpdateGroupPayload>;
  /** To update members of a group. */
  updateGroupMembers?: Maybe<UpdateGroupMembersPayload>;
  /** Updates a single `NotificationSubscription` using its globally unique id and a patch. */
  updateNotificationSubscription?: Maybe<UpdateNotificationSubscriptionPayload>;
  /** Updates a single `NotificationSubscription` using a unique key and a patch. */
  updateNotificationSubscriptionByUserIdAndWorkflowIdAndActionkey?: Maybe<UpdateNotificationSubscriptionPayload>;
  /** Updates a single `Workflow` using its globally unique id and a patch. */
  updateWorkflow?: Maybe<UpdateWorkflowPayload>;
  /** Updates a single `Workflow` using a unique key and a patch. */
  updateWorkflowByRowId?: Maybe<UpdateWorkflowPayload>;
  /** Updates a single `WorkflowConfig` using its globally unique id and a patch. */
  updateWorkflowConfig?: Maybe<UpdateWorkflowConfigPayload>;
  /** Updates a single `WorkflowConfig` using a unique key and a patch. */
  updateWorkflowConfigByRowId?: Maybe<UpdateWorkflowConfigPayload>;
  updateWorkflowDetails?: Maybe<Workflow>;
  /** Updates the documentation of a workflow. */
  updateWorkflowDocumentationByRowId?: Maybe<UpdateWorkflowDocumentationByRowIdPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddEvidenceArgs = {
  input: AddEvidenceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddTagsToTraceArgs = {
  input: AddTagsToTraceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAssignActionToGroupArgs = {
  input: AssignActionToGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLinkArgs = {
  input: CreateLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLinksArgs = {
  input?: InputMaybe<Array<CreateLinkInput>>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNotificationSubscriptionArgs = {
  input: CreateNotificationSubscriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkflowArgs = {
  input: CreateWorkflowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNotificationSubscriptionArgs = {
  input: DeleteNotificationSubscriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNotificationSubscriptionByUserIdAndWorkflowIdAndActionkeyArgs = {
  input: DeleteNotificationSubscriptionByUserIdAndWorkflowIdAndActionkeyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowArgs = {
  input: DeleteWorkflowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEditGroupMembershipArgs = {
  input: EditGroupMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEditWorkflowMembershipArgs = {
  input: EditWorkflowMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInviteUsersToGroupArgs = {
  input: InviteUsersToGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationNewWorkflowConfigArgs = {
  input: NewWorkflowConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveTagsFromTraceArgs = {
  input: RemoveTagsFromTraceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupByRowIdArgs = {
  input: UpdateGroupByRowIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupMembersArgs = {
  input: UpdateGroupMembersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNotificationSubscriptionArgs = {
  input: UpdateNotificationSubscriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNotificationSubscriptionByUserIdAndWorkflowIdAndActionkeyArgs = {
  input: UpdateNotificationSubscriptionByUserIdAndWorkflowIdAndActionkeyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowArgs = {
  input: UpdateWorkflowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowByRowIdArgs = {
  input: UpdateWorkflowByRowIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowConfigArgs = {
  input: UpdateWorkflowConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowConfigByRowIdArgs = {
  input: UpdateWorkflowConfigByRowIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowDetailsArgs = {
  input: UpdateWorkflowDetailsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowDocumentationByRowIdArgs = {
  input: UpdateWorkflowDocumentationByRowIdInput;
};

/** All input for the `newWorkflowConfig` mutation. */
export type NewWorkflowConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  config: NewWorkflowConfigInputRecordInput;
};

/** An input for mutations affecting `NewWorkflowConfigInputRecord` */
export type NewWorkflowConfigInputRecordInput = {
  /** The definition of all actions of a workflow. They should embed the forms and the effects for each action. */
  actions?: InputMaybe<Scalars['JSON']['input']>;
  /** Admin config defined by user in `admin-ui`. */
  admin?: InputMaybe<Scalars['JSON']['input']>;
  /** True to allow actions to be performed by bots, false to deny them. */
  allowAutomation?: InputMaybe<Scalars['Boolean']['input']>;
  /** DSL definitions that can be referenced from other parts of the configuration. */
  definitions?: InputMaybe<Scalars['JSON']['input']>;
  /** The display config for the trace info view. */
  info?: InputMaybe<Scalars['JSON']['input']>;
  /** The possible actions to start a trace. */
  initActions?: InputMaybe<Scalars['JSON']['input']>;
  /** The initial state of traces in this workflow. */
  initState?: InputMaybe<Scalars['JSON']['input']>;
  /** The migration that will run upon creating this workflow config entry (optional). */
  migration?: InputMaybe<Scalars['JSON']['input']>;
  /** The overview configuration of the workflow. */
  overview?: InputMaybe<Scalars['JSON']['input']>;
  /** The json-schema definition of the trace state. */
  stateSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** Describes the transitions between actions that are allowed on the workflow. */
  transitions?: InputMaybe<Scalars['JSON']['input']>;
  /** Version # of new workflowConfig, should be equal to currentConfig.version + 1. Used to prevent concurrency issues. */
  version?: InputMaybe<Scalars['BigInt']['input']>;
  /** The id of the workflow related to the config. */
  workflowRowId: Scalars['BigInt']['input'];
};

/** The output of our `newWorkflowConfig` mutation. */
export type NewWorkflowConfigPayload = {
  __typename?: 'NewWorkflowConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workflow` that is related to this `WorkflowConfig`. */
  workflow?: Maybe<Workflow>;
  workflowConfig?: Maybe<WorkflowConfig>;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
};

export type NotificationSubscription = Node & {
  __typename?: 'NotificationSubscription';
  actionkey: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
  subscription: NotificationSubscriptionMode;
  userId: Scalars['BigInt']['output'];
  /** Reads a single `Workflow` that is related to this `NotificationSubscription`. */
  workflow?: Maybe<Workflow>;
  workflowId: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `NotificationSubscription` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type NotificationSubscriptionCondition = {
  /** Checks for equality with the object’s `actionkey` field. */
  actionkey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `subscription` field. */
  subscription?: InputMaybe<NotificationSubscriptionMode>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `workflowId` field. */
  workflowId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `NotificationSubscription` object types. All fields are combined with a logical ‘and.’ */
export type NotificationSubscriptionFilter = {
  /** Filter by the object’s `actionkey` field. */
  actionkey?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationSubscriptionFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationSubscriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationSubscriptionFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `subscription` field. */
  subscription?: InputMaybe<NotificationSubscriptionModeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `workflowId` field. */
  workflowId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `NotificationSubscription` */
export type NotificationSubscriptionInput = {
  actionkey: Scalars['String']['input'];
  rowId?: InputMaybe<Scalars['Int']['input']>;
  subscription?: InputMaybe<NotificationSubscriptionMode>;
  userId: Scalars['BigInt']['input'];
  workflowId: Scalars['BigInt']['input'];
};

export enum NotificationSubscriptionMode {
  Always = 'ALWAYS',
  Custom = 'CUSTOM',
  Off = 'OFF'
}

/** A filter to be used against NotificationSubscriptionMode fields. All fields are combined with a logical ‘and.’ */
export type NotificationSubscriptionModeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<NotificationSubscriptionMode>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<NotificationSubscriptionMode>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<NotificationSubscriptionMode>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<NotificationSubscriptionMode>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<NotificationSubscriptionMode>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<NotificationSubscriptionMode>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<NotificationSubscriptionMode>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<NotificationSubscriptionMode>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<NotificationSubscriptionMode>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<NotificationSubscriptionMode>>;
};

/** Represents an update to a `NotificationSubscription`. Fields that are set will be updated. */
export type NotificationSubscriptionPatch = {
  actionkey?: InputMaybe<Scalars['String']['input']>;
  rowId?: InputMaybe<Scalars['Int']['input']>;
  subscription?: InputMaybe<NotificationSubscriptionMode>;
  userId?: InputMaybe<Scalars['BigInt']['input']>;
  workflowId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `NotificationSubscription` values. */
export type NotificationSubscriptionsConnection = {
  __typename?: 'NotificationSubscriptionsConnection';
  /** A list of edges which contains the `NotificationSubscription` and cursor to aid in pagination. */
  edges: Array<NotificationSubscriptionsEdge>;
  /** A list of `NotificationSubscription` objects. */
  nodes: Array<Maybe<NotificationSubscription>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NotificationSubscription` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `NotificationSubscription` edge in the connection. */
export type NotificationSubscriptionsEdge = {
  __typename?: 'NotificationSubscriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `NotificationSubscription` at the end of the edge. */
  node?: Maybe<NotificationSubscription>;
};

/** Methods to use when ordering `NotificationSubscription`. */
export enum NotificationSubscriptionsOrderBy {
  ActionkeyAsc = 'ACTIONKEY_ASC',
  ActionkeyDesc = 'ACTIONKEY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SubscriptionAsc = 'SUBSCRIPTION_ASC',
  SubscriptionDesc = 'SUBSCRIPTION_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  WorkflowIdAsc = 'WORKFLOW_ID_ASC',
  WorkflowIdDesc = 'WORKFLOW_ID_DESC'
}

export type NotificationsInput = {
  /** A list of account IDs to be notified by the link creation */
  accountIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Custom json to be sent to all recipients */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Custom message to be sent to all recipients, overrides default */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Custom title to be sent to all recipients, overrides default */
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

/** A connection to a list of `Priority` values. */
export type PrioritiesConnection = {
  __typename?: 'PrioritiesConnection';
  /** A list of edges which contains the `Priority` and cursor to aid in pagination. */
  edges: Array<PrioritiesEdge>;
  /** A list of `Priority` objects. */
  nodes: Array<Maybe<Priority>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Priority` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Priority` edge in the connection. */
export type PrioritiesEdge = {
  __typename?: 'PrioritiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Priority` at the end of the edge. */
  node?: Maybe<Priority>;
};

/** Methods to use when ordering `Priority`. */
export enum PrioritiesOrderBy {
  AllDesc = 'ALL_DESC',
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  InvestmentAsc = 'INVESTMENT_ASC',
  InvestmentDesc = 'INVESTMENT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ResponsibilityAsc = 'RESPONSIBILITY_ASC',
  ResponsibilityDesc = 'RESPONSIBILITY_DESC',
  TraceMapIdAsc = 'TRACE_MAP_ID_ASC',
  TraceMapIdDesc = 'TRACE_MAP_ID_DESC',
  UrgencyAsc = 'URGENCY_ASC',
  UrgencyDesc = 'URGENCY_DESC',
  WorkflowIdAsc = 'WORKFLOW_ID_ASC',
  WorkflowIdDesc = 'WORKFLOW_ID_DESC'
}

export type Priority = Node & {
  __typename?: 'Priority';
  /** Reads a single `Group` that is related to this `Priority`. */
  group?: Maybe<Group>;
  /** The affected group */
  groupId: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Determines the level of involvement a group has had on a trace */
  investment: Scalars['BigFloat']['output'];
  /** Determines how responsible the group is in regards to handling a trace */
  responsibility: Scalars['BigFloat']['output'];
  trace?: Maybe<Trace>;
  /** The affected trace */
  traceMapId: Scalars['UUID']['output'];
  /** Determines the level of urgency of a trace */
  urgency: Scalars['BigFloat']['output'];
  /** Reads a single `Workflow` that is related to this `Priority`. */
  workflow?: Maybe<Workflow>;
  /** The affected workflow */
  workflowId: Scalars['BigInt']['output'];
};

/** A filter to be used against `Priority` object types. All fields are combined with a logical ‘and.’ */
export type PriorityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PriorityFilter>>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `investment` field. */
  investment?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PriorityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PriorityFilter>>;
  /** Filter by the object’s `responsibility` field. */
  responsibility?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `traceMapId` field. */
  traceMapId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `urgency` field. */
  urgency?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `workflowId` field. */
  workflowId?: InputMaybe<BigIntFilter>;
};

export enum ProcessState {
  Free = 'FREE',
  Owned = 'OWNED',
  Pulling = 'PULLING',
  Pushing = 'PUSHING'
}

/** A filter to be used against ProcessState fields. All fields are combined with a logical ‘and.’ */
export type ProcessStateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ProcessState>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ProcessState>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ProcessState>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ProcessState>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ProcessState>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ProcessState>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ProcessState>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ProcessState>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ProcessState>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ProcessState>>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /**
   * Returns the latest version of a form given its identifier.
   * @deprecated Use workflow.action_by_key instead
   */
  formByIdentifier?: Maybe<Form>;
  /**
   * Returns the latest version of a form given its id.
   * @deprecated Use workflow.action_by_key instead
   */
  formByRowId?: Maybe<Form>;
  /** Reads a single `Group` using its globally unique `ID`. */
  group?: Maybe<Group>;
  groupByRowId?: Maybe<Group>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  id: Scalars['ID']['output'];
  /** Initialize link for attestation */
  initAttestationLink: Scalars['JSON']['output'];
  /**
   * Initialize link for transfer of ownership request
   * @deprecated Transfer of ownership now uses regular actions. Please use initAttestationLink instead.
   */
  initTransferRequest: Scalars['JSON']['output'];
  /**
   * Initialize link for accept/reject/cancel transfer of ownership response
   * @deprecated Transfer of ownership now uses regular actions. Please use initAttestationLink instead.
   */
  initTransferResponse: Scalars['JSON']['output'];
  /** Reads a single `Link` using its globally unique `ID`. */
  link?: Maybe<Link>;
  /** Current user information */
  me?: Maybe<Account_User>;
  missedLinks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Current user account information */
  myAccount?: Maybe<Account_Account>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** Reads a single `NotificationSubscription` using its globally unique `ID`. */
  notificationSubscription?: Maybe<NotificationSubscription>;
  notificationSubscriptionByUserIdAndWorkflowIdAndActionkey?: Maybe<NotificationSubscription>;
  /** Reads and enables pagination through a set of `NotificationSubscription`. */
  notificationSubscriptions?: Maybe<NotificationSubscriptionsConnection>;
  /** The numeric priorities of a trace for a group */
  priorities?: Maybe<PrioritiesConnection>;
  /** Reads a single `Priority` using its globally unique `ID`. */
  priority?: Maybe<Priority>;
  priorityByTraceMapIdAndGroupId?: Maybe<Priority>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Reads a single `Stage` using its globally unique `ID`. */
  stage?: Maybe<Stage>;
  stageByRowId?: Maybe<Stage>;
  /** Reads a single `Trace` using its globally unique `ID`. */
  trace?: Maybe<Trace>;
  traceById?: Maybe<Trace>;
  /** Reads and enables pagination through a set of `Trace`. */
  traceByIds?: Maybe<TracesConnection>;
  /** Reads a single `Workflow` using its globally unique `ID`. */
  workflow?: Maybe<Workflow>;
  workflowByRowId?: Maybe<Workflow>;
  /** Reads a single `WorkflowConfig` using its globally unique `ID`. */
  workflowConfig?: Maybe<WorkflowConfig>;
  workflowConfigByRowId?: Maybe<WorkflowConfig>;
  /** Reads and enables pagination through a set of `Workflow`. */
  workflows?: Maybe<WorkflowsConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFormByIdentifierArgs = {
  identifier?: InputMaybe<Scalars['BigInt']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFormByRowIdArgs = {
  rowId?: InputMaybe<Scalars['BigInt']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupArgs = {
  id: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupByRowIdArgs = {
  rowId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInitAttestationLinkArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  formData?: InputMaybe<Scalars['JSON']['input']>;
  formId?: InputMaybe<Scalars['BigInt']['input']>;
  formIdentifier?: InputMaybe<Scalars['BigInt']['input']>;
  groupId: Scalars['BigInt']['input'];
  hashed?: InputMaybe<Scalars['Boolean']['input']>;
  refs?: InputMaybe<Array<Ref>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<AttestationType>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInitTransferRequestArgs = {
  action: TransferRequestAction;
  formData?: InputMaybe<Scalars['JSON']['input']>;
  hashed?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  to: Scalars['BigInt']['input'];
  traceId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInitTransferResponseArgs = {
  action: TransferResponseAction;
  formData?: InputMaybe<Scalars['JSON']['input']>;
  hashed?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLinkArgs = {
  id: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationSubscriptionByUserIdAndWorkflowIdAndActionkeyArgs = {
  actionkey: Scalars['String']['input'];
  userId: Scalars['BigInt']['input'];
  workflowId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationSubscriptionCondition>;
  filter?: InputMaybe<NotificationSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationSubscriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPrioritiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PriorityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PrioritiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPriorityArgs = {
  id: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPriorityByTraceMapIdAndGroupIdArgs = {
  groupId: Scalars['BigInt']['input'];
  traceMapId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStageArgs = {
  id: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStageByRowIdArgs = {
  rowId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTraceArgs = {
  id: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTraceByIdArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTraceByIdsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  customFilter?: InputMaybe<TraceCustomFilter>;
  filter?: InputMaybe<TraceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkflowArgs = {
  id: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkflowByRowIdArgs = {
  rowId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkflowConfigArgs = {
  id: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkflowConfigByRowIdArgs = {
  rowId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkflowsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkflowCondition>;
  filter?: InputMaybe<WorkflowFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkflowsOrderBy>>;
};

/** Reference to another link in Trace */
export type Ref = {
  /** Hex encoded linkHash */
  linkHash: Scalars['String']['input'];
  /** Workflow id of the link that is being referenced */
  workflowId: Scalars['BigInt']['input'];
};

/** All input for the `removeTagsFromTrace` mutation. */
export type RemoveTagsFromTraceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  traceRowId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `removeTagsFromTrace` mutation. */
export type RemoveTagsFromTracePayload = {
  __typename?: 'RemoveTagsFromTracePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  trace?: Maybe<Trace>;
  /** An edge for our `Trace`. May be used by Relay 1. */
  traceEdge?: Maybe<TracesEdge>;
  /** Reads a single `Workflow` that is related to this `Trace`. */
  workflow?: Maybe<Workflow>;
};


/** The output of our `removeTagsFromTrace` mutation. */
export type RemoveTagsFromTracePayloadTraceEdgeArgs = {
  orderBy?: InputMaybe<Array<TracesOrderBy>>;
};

/** The role type. */
export enum RoleType {
  Admin = 'ADMIN',
  Reader = 'READER'
}

/** A Trace stage. */
export type Stage = Node & {
  __typename?: 'Stage';
  /** The action assigned to the stage */
  action?: Maybe<Action>;
  actionKey?: Maybe<Scalars['String']['output']>;
  /** Is the current user allowed to create a trace in this stage. */
  canCreateTrace?: Maybe<Scalars['Boolean']['output']>;
  /** The time when the stage was created. */
  createdAt: Scalars['Datetime']['output'];
  /**
   * The form of the stage.
   * @deprecated Use stage.action instead
   */
  form?: Maybe<Form>;
  /**
   * The ID of the form of the stage.
   * @deprecated Use stage.action_key instead
   */
  formId?: Maybe<Scalars['BigInt']['output']>;
  /**
   * The identifier of the form of the stage.
   * @deprecated Use stage.action_key instead
   */
  formIdentifier?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Group` that is related to this `Stage`. */
  group?: Maybe<Group>;
  /** The id of the group the stage belongs to. */
  groupId: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** The label of the stage. */
  label: Scalars['String']['output'];
  /** The id of the stage. */
  rowId: Scalars['BigInt']['output'];
  /** Traces that are currently in this stage. */
  traces: TracesConnection;
  /** The type of the stage. */
  type: StageType;
  /** The time when the stage was last updated. */
  updatedAt: Scalars['Datetime']['output'];
};


/** A Trace stage. */
export type StageTracesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  customFilter?: InputMaybe<TraceCustomFilter>;
  filter?: InputMaybe<TraceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A condition to be used against `Stage` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type StageCondition = {
  /** Checks for equality with the object’s `actionKey` field. */
  actionKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The ID of the form of the stage */
  formId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The identifier of the form of the stage */
  formIdentifier?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<StageType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Stage` object types. All fields are combined with a logical ‘and.’ */
export type StageFilter = {
  /** Filter by the object’s `actionKey` field. */
  actionKey?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<StageFilter>>;
  /** Filter by the object’s `canCreateTrace` field. */
  canCreateTrace?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `formId` field. */
  formId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `formIdentifier` field. */
  formIdentifier?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<StageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<StageFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StageTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A stage type enum. */
export enum StageType {
  Attestation = 'ATTESTATION',
  Backlog = 'BACKLOG',
  Incoming = 'INCOMING',
  Outgoing = 'OUTGOING'
}

/** A filter to be used against StageType fields. All fields are combined with a logical ‘and.’ */
export type StageTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<StageType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<StageType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<StageType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<StageType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<StageType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<StageType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<StageType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<StageType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<StageType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<StageType>>;
};

/** A connection to a list of `Stage` values. */
export type StagesConnection = {
  __typename?: 'StagesConnection';
  /** A list of edges which contains the `Stage` and cursor to aid in pagination. */
  edges: Array<StagesEdge>;
  /** A list of `Stage` objects. */
  nodes: Array<Maybe<Stage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Stage` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Stage` edge in the connection. */
export type StagesEdge = {
  __typename?: 'StagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Stage` at the end of the edge. */
  node?: Maybe<Stage>;
};

/** Methods to use when ordering `Stage`. */
export enum StagesOrderBy {
  ActionKeyAsc = 'ACTION_KEY_ASC',
  ActionKeyDesc = 'ACTION_KEY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LabelAsc = 'LABEL_ASC',
  LabelDesc = 'LABEL_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /**
   * Matches the specified pattern (case-sensitive). An underscore (_) matches any
   * single character; a percent sign (%) matches any sequence of zero or more characters.
   */
  like?: InputMaybe<Scalars['String']['input']>;
  /**
   * Matches the specified pattern (case-insensitive). An underscore (_) matches
   * any single character; a percent sign (%) matches any sequence of zero or more characters.
   */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /**
   * Does not match the specified pattern (case-sensitive). An underscore (_)
   * matches any single character; a percent sign (%) matches any sequence of zero
   * or more characters.
   */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /**
   * Does not match the specified pattern (case-insensitive). An underscore (_)
   * matches any single character; a percent sign (%) matches any sequence of zero
   * or more characters.
   */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A trace. */
export type Trace = Node & {
  __typename?: 'Trace';
  /** The time when the trace was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Group to which the trace belongs. */
  group?: Maybe<Group>;
  /** Get the head of the trace. */
  head?: Maybe<Link>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Get the links of the trace. */
  links: LinksConnection;
  /** The user friendly name for the trace. */
  name?: Maybe<Scalars['String']['output']>;
  /** List of the groups to whom a trace can be transferred. */
  nextGroups: GroupsConnection;
  /** All the accounts that can access the trace */
  readers: Array<Maybe<TraceReader>>;
  /** The identifier of the trace. */
  rowId?: Maybe<Scalars['String']['output']>;
  /** The short identifier of the trace. */
  shortId?: Maybe<Scalars['String']['output']>;
  /** Stages in which this trace is. */
  stages: StagesConnection;
  /** The state of the trace. */
  state?: Maybe<TraceState>;
  /** The list of tags of the link. */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Get the first link of the trace. */
  tail?: Maybe<Link>;
  /** The time when the trace was last updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `Workflow` that is related to this `Trace`. */
  workflow?: Maybe<Workflow>;
  /** The id of the workflow the trace belongs to. */
  workflowId: Scalars['BigInt']['output'];
};


/** A trace. */
export type TraceLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<LinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A trace. */
export type TraceNextGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A trace. */
export type TraceStagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<StageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A condition to be used against `Trace` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type TraceCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `workflowId` field. */
  workflowId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A customized filter to be used against `Trace` object types. All fields are combined with a logical ‘and.’ */
export type TraceCustomFilter = {
  /** blah */
  _?: InputMaybe<Scalars['String']['input']>;
  /** String in custom filter */
  byHeadTags?: InputMaybe<Scalars['String']['input']>;
  /** JSON in custom filter */
  byStateDataProperties?: InputMaybe<Scalars['JSON']['input']>;
  /** String in custom filter */
  byTags?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Trace` object types. All fields are combined with a logical ‘and.’ */
export type TraceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TraceFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TraceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TraceFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `shortId` field. */
  shortId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tags` field. */
  tags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `workflowId` field. */
  workflowId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `TraceFilterByStateDatum` */
export type TraceFilterByStateDatumInput = {
  format?: InputMaybe<Scalars['String']['input']>;
  inputFormat?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** An input for mutations affecting `TraceOrderByStateDatum` */
export type TraceOrderByStateDatumInput = {
  direction?: InputMaybe<OrderByDirection>;
  path?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TraceReader = {
  __typename?: 'TraceReader';
  /** Account id in Stratumn account. */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  accountType?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The state of a trace. */
export type TraceState = Node & {
  __typename?: 'TraceState';
  /** The time when the state was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The data of the trace state. */
  data: Scalars['JSON']['output'];
  /** The head link of the trace. */
  headLink?: Maybe<Link>;
  headLinkHash: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** The metadata of the trace state */
  meta: Scalars['JSON']['output'];
  /** The actions that can be done from this trace per group */
  nextActions?: Maybe<Scalars['JSON']['output']>;
  /** The last action notifications sent */
  notifications?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** ID of the state. */
  rowId: Scalars['BigInt']['output'];
  tasks?: Maybe<Scalars['JSON']['output']>;
  /** The trace associated with the state. */
  trace?: Maybe<Trace>;
  /** The ID of the trace. */
  traceId: Scalars['UUID']['output'];
  /** The time when the state was last upadted. */
  updatedAt: Scalars['Datetime']['output'];
};

export enum TraceStateColumn {
  Data = 'DATA',
  Meta = 'META'
}

/** A filter to be used against `TraceState` object types. All fields are combined with a logical ‘and.’ */
export type TraceStateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TraceStateFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `data` field. */
  data?: InputMaybe<JsonFilter>;
  /** Filter on a value following a path in the data JSON object */
  dataByPath?: InputMaybe<JsonDeepFilter>;
  /** Filter by the object’s `meta` field. */
  meta?: InputMaybe<JsonFilter>;
  /** Filter on a value following a path in the meta JSON object */
  metaByPath?: InputMaybe<JsonDeepFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TraceStateFilter>;
  /** Filter by the object’s `notifications` field. */
  notifications?: InputMaybe<JsonListFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TraceStateFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `tasks` field. */
  tasks?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `traceId` field. */
  traceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `TraceState` values. */
export type TraceStatesConnection = {
  __typename?: 'TraceStatesConnection';
  /** A list of edges which contains the `TraceState` and cursor to aid in pagination. */
  edges: Array<TraceStatesEdge>;
  /** A list of `TraceState` objects. */
  nodes: Array<Maybe<TraceState>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TraceState` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TraceState` edge in the connection. */
export type TraceStatesEdge = {
  __typename?: 'TraceStatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TraceState` at the end of the edge. */
  node?: Maybe<TraceState>;
};

/** Used to order workflow traces states */
export type TraceStatesOrderByPath = {
  column: TraceStateColumn;
  direction?: InputMaybe<OrderDirection>;
  path: Scalars['String']['input'];
};

/** A connection to a list of `Trace` values. */
export type TracesConnection = {
  __typename?: 'TracesConnection';
  /** A list of edges which contains the `Trace` and cursor to aid in pagination. */
  edges: Array<TracesEdge>;
  /** A list of `Trace` objects. */
  nodes: Array<Maybe<Trace>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Trace` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Trace` edge in the connection. */
export type TracesEdge = {
  __typename?: 'TracesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Trace` at the end of the edge. */
  node?: Maybe<Trace>;
};

/** Methods to use when ordering `Trace`. */
export enum TracesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WorkflowIdAsc = 'WORKFLOW_ID_ASC',
  WorkflowIdDesc = 'WORKFLOW_ID_DESC'
}

export enum TransferRequestAction {
  PushOwnership = '_PUSH_OWNERSHIP_'
}

export enum TransferResponseAction {
  AcceptTransfer = '_ACCEPT_TRANSFER_',
  CancelTransfer = '_CANCEL_TRANSFER_',
  RejectTransfer = '_REJECT_TRANSFER_'
}

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** All input for the `updateGroupByRowId` mutation. */
export type UpdateGroupByRowIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Group` being updated. */
  patch: GroupPatch;
  /** The id of the group. */
  rowId: Scalars['BigInt']['input'];
};

/** All input for the `updateGroup` mutation. */
export type UpdateGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Group` to be updated. */
  id: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Group` being updated. */
  patch: GroupPatch;
};

/** An input for mutations affecting `UpdateGroupMemberAction` */
export type UpdateGroupMemberActionInput = {
  action?: InputMaybe<EditMembershipActionType>;
  memberId?: InputMaybe<Scalars['BigInt']['input']>;
  role?: InputMaybe<RoleType>;
};

/** All input for the `updateGroupMembers` mutation. */
export type UpdateGroupMembersInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['BigInt']['input']>;
  members?: InputMaybe<Array<InputMaybe<UpdateGroupMemberActionInput>>>;
};

/** The output of our `updateGroupMembers` mutation. */
export type UpdateGroupMembersPayload = {
  __typename?: 'UpdateGroupMembersPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workflow` that is related to this `Group`. */
  workflow?: Maybe<Workflow>;
};


/** The output of our `updateGroupMembers` mutation. */
export type UpdateGroupMembersPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** The output of our update `Group` mutation. */
export type UpdateGroupPayload = {
  __typename?: 'UpdateGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Group` that was updated by this mutation. */
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workflow` that is related to this `Group`. */
  workflow?: Maybe<Workflow>;
};


/** The output of our update `Group` mutation. */
export type UpdateGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** All input for the `updateNotificationSubscriptionByUserIdAndWorkflowIdAndActionkey` mutation. */
export type UpdateNotificationSubscriptionByUserIdAndWorkflowIdAndActionkeyInput = {
  actionkey: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `NotificationSubscription` being updated. */
  patch: NotificationSubscriptionPatch;
  userId: Scalars['BigInt']['input'];
  workflowId: Scalars['BigInt']['input'];
};

/** All input for the `updateNotificationSubscription` mutation. */
export type UpdateNotificationSubscriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `NotificationSubscription` to be updated. */
  id: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `NotificationSubscription` being updated. */
  patch: NotificationSubscriptionPatch;
};

/** The output of our update `NotificationSubscription` mutation. */
export type UpdateNotificationSubscriptionPayload = {
  __typename?: 'UpdateNotificationSubscriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `NotificationSubscription` that was updated by this mutation. */
  notificationSubscription?: Maybe<NotificationSubscription>;
  /** An edge for our `NotificationSubscription`. May be used by Relay 1. */
  notificationSubscriptionEdge?: Maybe<NotificationSubscriptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workflow` that is related to this `NotificationSubscription`. */
  workflow?: Maybe<Workflow>;
};


/** The output of our update `NotificationSubscription` mutation. */
export type UpdateNotificationSubscriptionPayloadNotificationSubscriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationSubscriptionsOrderBy>>;
};

/** All input for the `updateWorkflowByRowId` mutation. */
export type UpdateWorkflowByRowIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Workflow` being updated. */
  patch: WorkflowPatch;
  /** The id of the workflow. */
  rowId: Scalars['BigInt']['input'];
};

/** All input for the `updateWorkflowConfigByRowId` mutation. */
export type UpdateWorkflowConfigByRowIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `WorkflowConfig` being updated. */
  patch: WorkflowConfigPatch;
  /** ID of the workflow config. */
  rowId: Scalars['BigInt']['input'];
};

/** All input for the `updateWorkflowConfig` mutation. */
export type UpdateWorkflowConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `WorkflowConfig` to be updated. */
  id: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `WorkflowConfig` being updated. */
  patch: WorkflowConfigPatch;
};

/** The output of our update `WorkflowConfig` mutation. */
export type UpdateWorkflowConfigPayload = {
  __typename?: 'UpdateWorkflowConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workflow` that is related to this `WorkflowConfig`. */
  workflow?: Maybe<Workflow>;
  /** The `WorkflowConfig` that was updated by this mutation. */
  workflowConfig?: Maybe<WorkflowConfig>;
};

export type UpdateWorkflowDetailsInput = {
  config?: InputMaybe<WorkflowConfigInputRecordInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  workflowId: Scalars['BigInt']['input'];
};

/** All input for the `updateWorkflowDocumentationByRowId` mutation. */
export type UpdateWorkflowDocumentationByRowIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fileDigest?: InputMaybe<Scalars['String']['input']>;
  rowId?: InputMaybe<Scalars['BigInt']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `updateWorkflowDocumentationByRowId` mutation. */
export type UpdateWorkflowDocumentationByRowIdPayload = {
  __typename?: 'UpdateWorkflowDocumentationByRowIdPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  workflow?: Maybe<Workflow>;
  /** An edge for our `Workflow`. May be used by Relay 1. */
  workflowEdge?: Maybe<WorkflowsEdge>;
};


/** The output of our `updateWorkflowDocumentationByRowId` mutation. */
export type UpdateWorkflowDocumentationByRowIdPayloadWorkflowEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowsOrderBy>>;
};

/** All input for the `updateWorkflow` mutation. */
export type UpdateWorkflowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Workflow` to be updated. */
  id: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Workflow` being updated. */
  patch: WorkflowPatch;
};

/** The output of our update `Workflow` mutation. */
export type UpdateWorkflowPayload = {
  __typename?: 'UpdateWorkflowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Workflow` that was updated by this mutation. */
  workflow?: Maybe<Workflow>;
  /** An edge for our `Workflow`. May be used by Relay 1. */
  workflowEdge?: Maybe<WorkflowsEdge>;
};


/** The output of our update `Workflow` mutation. */
export type UpdateWorkflowPayloadWorkflowEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowsOrderBy>>;
};

/** A Trace workflow. */
export type Workflow = Node & {
  __typename?: 'Workflow';
  /**
   * The account that owns the workflow.
   * @deprecated use workflow.owner instead
   */
  account?: Maybe<Account_Account>;
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Gets an action according to its key */
  actionByKey?: Maybe<Action>;
  /** Gets the actions of the workflow */
  actions: ActionsConnection;
  /** Is the current user allowed to update this workflow. */
  canUpdate?: Maybe<Scalars['Boolean']['output']>;
  config?: Maybe<WorkflowConfig>;
  /** The time when the workflow was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The account that created the workflow. */
  createdBy?: Maybe<Account_Account>;
  /** The description of the workflow. */
  description?: Maybe<Scalars['String']['output']>;
  /** The user provided documentation for the workflow. */
  documentation?: Maybe<Documentation>;
  /** Denotes whether or not this workflow is a draft */
  draft: Scalars['Boolean']['output'];
  /**
   * Returns all of the active forms for this workflow.
   * @deprecated Use workflow.actions instead
   */
  forms: FormsConnection;
  /** Returns groups of trace states indexed by value of their state. The "path" argument must use the dot-notation. */
  groupedTraceStates: GroupedTraceStatesConnection;
  /** Returns groups of traces indexed by value of their state. The "path" argument must use the dot-notation. */
  groupedTraces: GroupedTracesConnection;
  /** Reads and enables pagination through a set of `Group`. */
  groups: GroupsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the current user is a workflow reader. */
  isReader?: Maybe<Scalars['Boolean']['output']>;
  /** The last migration that was run on the workflow */
  lastMigration?: Maybe<Scalars['JSON']['output']>;
  /** Get all the links of the workflow */
  links: LinksConnection;
  /** Reads and enables pagination through a set of `WorkflowMember`. */
  members: WorkflowMembersConnection;
  /** The name of the workflow. */
  name: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `NotificationSubscription`. */
  notificationSubscriptions: NotificationSubscriptionsConnection;
  /** Update (add & delete) notification subscriptions for a user according to workflow config */
  notificationSubscriptionsUpdated: NotificationSubscriptionsConnection;
  /**
   * Dont't use this its deprecated!
   * @deprecated Use `WorkflowConfig`.`overview` instead.
   */
  overviewConfig?: Maybe<Scalars['JSON']['output']>;
  /** The account that owns the workflow. */
  owner?: Maybe<Account_Account>;
  /** The ID of the account owning the workflow. */
  ownerId: Scalars['BigInt']['output'];
  /** Gets the raw JSON content of an action as according to its key */
  rawActionByKey?: Maybe<Scalars['JSON']['output']>;
  /** The id of the workflow. */
  rowId: Scalars['BigInt']['output'];
  /** jsonb object for workflow configuration */
  settings?: Maybe<Scalars['JSON']['output']>;
  /** List of trace states belonging to this workflow */
  traceStates: TraceStatesConnection;
  /** List of traces belonging to this workflow */
  traces: TracesConnection;
  /** Reads and enables pagination through a set of `Trace`. */
  tracesDeprecated: TracesConnection;
  /** The time when the workflow was last updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** The account that last updated the workflow. */
  updatedBy?: Maybe<Account_Account>;
};


/** A Trace workflow. */
export type WorkflowActionByKeyArgs = {
  actionKey?: InputMaybe<Scalars['String']['input']>;
  test?: InputMaybe<Scalars['String']['input']>;
  traceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A Trace workflow. */
export type WorkflowActionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ActionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A Trace workflow. */
export type WorkflowFormsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FormFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A Trace workflow. */
export type WorkflowGroupedTraceStatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GroupedTraceStateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};


/** A Trace workflow. */
export type WorkflowGroupedTracesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GroupedTraceFilter>;
  filterBy?: InputMaybe<Array<InputMaybe<TraceFilterByStateDatumInput>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TraceOrderByStateDatumInput>;
  path?: InputMaybe<Scalars['String']['input']>;
};


/** A Trace workflow. */
export type WorkflowGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


/** A Trace workflow. */
export type WorkflowLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<LinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A Trace workflow. */
export type WorkflowMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<WorkflowMemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A Trace workflow. */
export type WorkflowNotificationSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationSubscriptionCondition>;
  filter?: InputMaybe<NotificationSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationSubscriptionsOrderBy>>;
};


/** A Trace workflow. */
export type WorkflowNotificationSubscriptionsUpdatedArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationSubscriptionCondition>;
  filter?: InputMaybe<NotificationSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationSubscriptionsOrderBy>>;
};


/** A Trace workflow. */
export type WorkflowRawActionByKeyArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


/** A Trace workflow. */
export type WorkflowTraceStatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TraceStateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TraceStatesOrderByPath>>;
};


/** A Trace workflow. */
export type WorkflowTracesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  customFilter?: InputMaybe<TraceCustomFilter>;
  filter?: InputMaybe<TraceFilter>;
  filterBy?: InputMaybe<Array<InputMaybe<TraceFilterByStateDatumInput>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TraceOrderByStateDatumInput>;
};


/** A Trace workflow. */
export type WorkflowTracesDeprecatedArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TraceCondition>;
  customFilter?: InputMaybe<TraceCustomFilter>;
  filter?: InputMaybe<TraceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TracesOrderBy>>;
};

/**
 * A condition to be used against `Workflow` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type WorkflowCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `documentation` field. */
  documentation?: InputMaybe<DocumentationInput>;
  /** Checks for equality with the object’s `draft` field. */
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ownerId` field. */
  ownerId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `settings` field. */
  settings?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** The config of a workflow. */
export type WorkflowConfig = Node & {
  __typename?: 'WorkflowConfig';
  /** The actions relative to the business logic of the workflow. */
  actions?: Maybe<Scalars['JSON']['output']>;
  /** Denotes whether or not this is the active version of the config. */
  active: Scalars['Boolean']['output'];
  /** Admin config defined by user in `admin-ui`. */
  admin?: Maybe<Scalars['JSON']['output']>;
  /** Does this workflow allow automation in action effects */
  allowAutomation?: Maybe<Scalars['Boolean']['output']>;
  /** The time when the config was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The account that created the config. */
  createdBy?: Maybe<Account_Account>;
  /** DSL definitions that can be referenced from other parts of the configuration. */
  definitions?: Maybe<Scalars['JSON']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** The display config for the trace info view. */
  info?: Maybe<Scalars['JSON']['output']>;
  /**
   * The actions that may be used to start a trace.
   * @deprecated Use workflowConfig.transitions instead
   */
  initActions?: Maybe<Scalars['JSON']['output']>;
  /** The initial state of each trace in the workflow. */
  initState?: Maybe<Scalars['JSON']['output']>;
  /** Reads and enables pagination through a set of `Link`. */
  links: LinksConnection;
  /** The migration that has been run upon creating this workflow config entry. */
  migration?: Maybe<Scalars['JSON']['output']>;
  /** The overview configuration of the workflow. */
  overview?: Maybe<Scalars['JSON']['output']>;
  /** Workflow actions without DSL reference evaluation */
  rawActions?: Maybe<Scalars['JSON']['output']>;
  /** Trace info configuration without DSL reference evaluation */
  rawInfo?: Maybe<Scalars['JSON']['output']>;
  /** Overview table configuration without DSL reference evaluation */
  rawOverview?: Maybe<Scalars['JSON']['output']>;
  /** ID of the workflow config. */
  rowId: Scalars['BigInt']['output'];
  /** The JSON schema of the workflow state. */
  stateSchema?: Maybe<Scalars['JSON']['output']>;
  /** Describes the transitions between actions that are allowed on the workflow. */
  transitions?: Maybe<Scalars['JSON']['output']>;
  /** The time when the config was last upadted. */
  updatedAt: Scalars['Datetime']['output'];
  /** The account that last updated the config. */
  updatedBy?: Maybe<Account_Account>;
  /** The version number of the config. */
  version: Scalars['BigInt']['output'];
  /** Reads a single `Workflow` that is related to this `WorkflowConfig`. */
  workflow?: Maybe<Workflow>;
  /** The ID of the workflow. */
  workflowId: Scalars['BigInt']['output'];
};


/** The config of a workflow. */
export type WorkflowConfigLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LinkCondition>;
  filter?: InputMaybe<LinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LinksOrderBy>>;
};

export type WorkflowConfigInputRecordInput = {
  actions?: InputMaybe<Scalars['JSON']['input']>;
  admin?: InputMaybe<Scalars['JSON']['input']>;
  allowAutomation?: InputMaybe<Scalars['Boolean']['input']>;
  definitions?: InputMaybe<Scalars['JSON']['input']>;
  info?: InputMaybe<Scalars['JSON']['input']>;
  initActions?: InputMaybe<Scalars['JSON']['input']>;
  initState?: InputMaybe<Scalars['JSON']['input']>;
  migration?: InputMaybe<Scalars['JSON']['input']>;
  overview?: InputMaybe<Scalars['JSON']['input']>;
  stateSchema?: InputMaybe<Scalars['JSON']['input']>;
  transitions?: InputMaybe<Scalars['JSON']['input']>;
  version?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Represents an update to a `WorkflowConfig`. Fields that are set will be updated. */
export type WorkflowConfigPatch = {
  /** Admin config defined by user in `admin-ui`. */
  admin?: InputMaybe<Scalars['JSON']['input']>;
  /** Does this workflow allow automation in action effects */
  allowAutomation?: InputMaybe<Scalars['Boolean']['input']>;
  /** DSL definitions that can be referenced from other parts of the configuration. */
  definitions?: InputMaybe<Scalars['JSON']['input']>;
  /** The display config for the trace info view. */
  info?: InputMaybe<Scalars['JSON']['input']>;
  /** The migration that has been run upon creating this workflow config entry. */
  migration?: InputMaybe<Scalars['JSON']['input']>;
  /** The overview configuration of the workflow. */
  overview?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `Workflow` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkflowFilter>>;
  /** Filter by the object’s `canUpdate` field. */
  canUpdate?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentation` field. */
  documentation?: InputMaybe<DocumentationFilter>;
  /** Filter by the object’s `draft` field. */
  draft?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isAdmin` field. */
  isAdmin?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isReader` field. */
  isReader?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastMigration` field. */
  lastMigration?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkflowFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkflowFilter>>;
  /** Filter by the object’s `ownerId` field. */
  ownerId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `settings` field. */
  settings?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `WorkflowInputRecord` */
export type WorkflowInputRecordInput = {
  /** The description of the workflow. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the workflow. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The Account ID of the organization that owns the workflow. */
  ownerId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The workflow settings. */
  settings?: InputMaybe<Scalars['JSON']['input']>;
};

export type WorkflowMember = {
  __typename?: 'WorkflowMember';
  /** The account of the member entity. */
  account?: Maybe<Account_Account>;
  /** Account id in Stratumn account. */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Is the member an admin. */
  admin?: Maybe<Scalars['Boolean']['output']>;
  /** Is the member a reader. */
  reader?: Maybe<Scalars['Boolean']['output']>;
};

/** A filter to be used against `WorkflowMember` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowMemberFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `admin` field. */
  admin?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkflowMemberFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<WorkflowMemberFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkflowMemberFilter>>;
  /** Filter by the object’s `reader` field. */
  reader?: InputMaybe<BooleanFilter>;
};

/** A connection to a list of `WorkflowMember` values. */
export type WorkflowMembersConnection = {
  __typename?: 'WorkflowMembersConnection';
  /** A list of edges which contains the `WorkflowMember` and cursor to aid in pagination. */
  edges: Array<WorkflowMembersEdge>;
  /** A list of `WorkflowMember` objects. */
  nodes: Array<Maybe<WorkflowMember>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkflowMember` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `WorkflowMember` edge in the connection. */
export type WorkflowMembersEdge = {
  __typename?: 'WorkflowMembersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `WorkflowMember` at the end of the edge. */
  node?: Maybe<WorkflowMember>;
};

/** Represents an update to a `Workflow`. Fields that are set will be updated. */
export type WorkflowPatch = {
  /** The description of the workflow. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Denotes whether or not this workflow is a draft */
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the workflow. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Dont't use this its deprecated! */
  overviewConfig?: InputMaybe<Scalars['JSON']['input']>;
  /** jsonb object for workflow configuration */
  settings?: InputMaybe<Scalars['JSON']['input']>;
};

/** A connection to a list of `Workflow` values. */
export type WorkflowsConnection = {
  __typename?: 'WorkflowsConnection';
  /** A list of edges which contains the `Workflow` and cursor to aid in pagination. */
  edges: Array<WorkflowsEdge>;
  /** A list of `Workflow` objects. */
  nodes: Array<Maybe<Workflow>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Workflow` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Workflow` edge in the connection. */
export type WorkflowsEdge = {
  __typename?: 'WorkflowsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Workflow` at the end of the edge. */
  node?: Maybe<Workflow>;
};

/** Methods to use when ordering `Workflow`. */
export enum WorkflowsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DocumentationAsc = 'DOCUMENTATION_ASC',
  DocumentationDesc = 'DOCUMENTATION_DESC',
  DraftAsc = 'DRAFT_ASC',
  DraftDesc = 'DRAFT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OwnerIdAsc = 'OWNER_ID_ASC',
  OwnerIdDesc = 'OWNER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SettingsAsc = 'SETTINGS_ASC',
  SettingsDesc = 'SETTINGS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type NewLinkFragmentFragment = { __typename?: 'Workflow', rowId: string, name: string, rawActionByKey?: unknown | null, config?: { __typename?: 'WorkflowConfig', actions?: unknown | null, rowId: string } | null, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', rowId: string, label: string, name: string, avatar?: string | null } | null> }, actionByKey?: { __typename?: 'Action', dataImporter?: unknown | null, dataEditor?: unknown | null, form?: { __typename?: 'ActionForm', schema?: unknown | null, uiSchema?: unknown | null } | null } | null, traces: { __typename?: 'TracesConnection', nodes: Array<{ __typename?: 'Trace', rowId?: string | null, name?: string | null, readers: Array<{ __typename?: 'TraceReader', accountId?: string | null, name?: string | null, accountType?: string | null } | null>, state?: { __typename?: 'TraceState', meta: unknown, rowId: string, data: unknown, nextActions?: unknown | null, trace?: { __typename?: 'Trace', rowId?: string | null, head?: { __typename?: 'Link', linkHash?: string | null, createdByAccount?: { __typename?: 'Account_Account', rowId: number, entity?: { __typename: 'Account_Account' } | { __typename: 'Account_Bot', rowId: number, name: string } | { __typename: 'Account_IsSuperuser' } | { __typename: 'Account_Key' } | { __typename: 'Account_Organization' } | { __typename: 'Account_PrivateKey' } | { __typename: 'Account_Team' } | { __typename: 'Account_User', rowId: number, name: string } | null } | null } | null } | null } | null, workflow?: { __typename?: 'Workflow', rowId: string, config?: { __typename?: 'WorkflowConfig', rowId: string, info?: unknown | null } | null } | null } | null> } };

export type DashboardUserFragmentFragment = { __typename?: 'Query', workflows?: { __typename?: 'WorkflowsConnection', nodes: Array<{ __typename?: 'Workflow', rowId: string, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', rowId: string, name: string, avatar?: string | null, canActQuick?: boolean | null } | null> } } | null> } | null };

export type WorkflowQueryQueryVariables = Exact<{
  workflowId: Scalars['BigInt']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['Cursor']['input']>;
  orderBy?: InputMaybe<Array<TraceStatesOrderByPath> | TraceStatesOrderByPath>;
  filter?: InputMaybe<TraceStateFilter>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type WorkflowQueryQuery = { __typename?: 'Query', workflowByRowId?: { __typename?: 'Workflow', rowId: string, name: string, canUpdate?: boolean | null, isReader?: boolean | null, config?: { __typename?: 'WorkflowConfig', rowId: string, overview?: unknown | null, initState?: unknown | null, initActions?: unknown | null, stateSchema?: unknown | null, actions?: unknown | null, transitions?: unknown | null } | null, groupedTraceStates: { __typename?: 'GroupedTraceStatesConnection', nodes: Array<{ __typename?: 'GroupedTraceState', index?: string | null, traceStates: { __typename?: 'TraceStatesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes: Array<{ __typename?: 'TraceState', rowId: string, data: unknown, meta: unknown, trace?: { __typename?: 'Trace', rowId?: string | null } | null } | null> } } | null> }, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', rowId: string, label: string, name: string, avatar?: string | null, canAct?: boolean | null } | null> } } | null };

export type TraceByIdsQueryVariables = Exact<{
  traceIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type TraceByIdsQuery = { __typename?: 'Query', traceByIds?: { __typename?: 'TracesConnection', nodes: Array<{ __typename?: 'Trace', rowId?: string | null, state?: { __typename?: 'TraceState', nextActions?: unknown | null } | null } | null> } | null };

export type UpdateWorkflowConfigMutationMutationVariables = Exact<{
  workflowRowId: Scalars['BigInt']['input'];
  newInitState?: InputMaybe<Scalars['JSON']['input']>;
  newInitActions?: InputMaybe<Scalars['JSON']['input']>;
  newStateSchema?: InputMaybe<Scalars['JSON']['input']>;
  newActions?: InputMaybe<Scalars['JSON']['input']>;
  newTransitions?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UpdateWorkflowConfigMutationMutation = { __typename?: 'Mutation', newWorkflowConfig?: { __typename?: 'NewWorkflowConfigPayload', workflow?: { __typename?: 'Workflow', rowId: string, config?: { __typename?: 'WorkflowConfig', rowId: string, overview?: unknown | null, initState?: unknown | null, initActions?: unknown | null, stateSchema?: unknown | null, actions?: unknown | null, transitions?: unknown | null } | null } | null } | null };

export type UserOrganizationTeamsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UserOrganizationTeamsQueryQuery = { __typename?: 'Query', me?: { __typename?: 'Account_User', rowId: number, organizations: { __typename?: 'Account_OrganizationsConnection', nodes: Array<{ __typename?: 'Account_Organization', rowId: number, teams: { __typename?: 'Account_TeamsConnection', totalCount: number, nodes: Array<{ __typename?: 'Account_Team', rowId: number, name: string, accountId: number, avatar?: string | null, members: { __typename?: 'Account_MembersConnection', totalCount: number }, bots: { __typename?: 'Account_BotsConnection', totalCount: number } } | null> } } | null> } } | null };

export type GroupSettingsFragmentFragment = { __typename?: 'Group', rowId: string, id: string, createdAt: string, updatedAt: string, label: string, name: string, avatar?: string | null, workflow?: { __typename?: 'Workflow', rowId: string, name: string } | null, members: { __typename?: 'GroupMembersConnection', totalCount: number, nodes: Array<{ __typename?: 'GroupMember', accountId?: string | null, reader?: boolean | null, admin?: boolean | null, account?: { __typename?: 'Account_Account', rowId: number, id: string, entity?: { __typename?: 'Account_Account' } | { __typename?: 'Account_Bot', rowId: number, name: string, avatar?: string | null } | { __typename?: 'Account_IsSuperuser' } | { __typename?: 'Account_Key' } | { __typename?: 'Account_Organization', rowId: number, name: string, avatar?: string | null, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null, user?: { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean } | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number, name: string, avatar?: string | null } | null> } } | { __typename?: 'Account_PrivateKey' } | { __typename?: 'Account_Team', rowId: number, name: string, avatar?: string | null, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null, user?: { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean } | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number, name: string, avatar?: string | null } | null> } } | { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean } | null } | null } | null> } };

export type GroupMemberFragmentFragment = { __typename?: 'GroupMember', accountId?: string | null, reader?: boolean | null, admin?: boolean | null, account?: { __typename?: 'Account_Account', rowId: number, id: string, entity?: { __typename?: 'Account_Account' } | { __typename?: 'Account_Bot', rowId: number, name: string, avatar?: string | null } | { __typename?: 'Account_IsSuperuser' } | { __typename?: 'Account_Key' } | { __typename?: 'Account_Organization', rowId: number, name: string, avatar?: string | null, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null, user?: { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean } | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number, name: string, avatar?: string | null } | null> } } | { __typename?: 'Account_PrivateKey' } | { __typename?: 'Account_Team', rowId: number, name: string, avatar?: string | null, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null, user?: { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean } | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number, name: string, avatar?: string | null } | null> } } | { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean } | null } | null };

export type UserFragmentFragment = { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean };

export type GroupSettingsQueryQueryVariables = Exact<{
  groupRowId: Scalars['BigInt']['input'];
}>;


export type GroupSettingsQueryQuery = { __typename?: 'Query', groupByRowId?: { __typename?: 'Group', rowId: string, id: string, createdAt: string, updatedAt: string, label: string, name: string, avatar?: string | null, workflow?: { __typename?: 'Workflow', rowId: string, name: string } | null, members: { __typename?: 'GroupMembersConnection', totalCount: number, nodes: Array<{ __typename?: 'GroupMember', accountId?: string | null, reader?: boolean | null, admin?: boolean | null, account?: { __typename?: 'Account_Account', rowId: number, id: string, entity?: { __typename?: 'Account_Account' } | { __typename?: 'Account_Bot', rowId: number, name: string, avatar?: string | null } | { __typename?: 'Account_IsSuperuser' } | { __typename?: 'Account_Key' } | { __typename?: 'Account_Organization', rowId: number, name: string, avatar?: string | null, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null, user?: { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean } | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number, name: string, avatar?: string | null } | null> } } | { __typename?: 'Account_PrivateKey' } | { __typename?: 'Account_Team', rowId: number, name: string, avatar?: string | null, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null, user?: { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean } | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number, name: string, avatar?: string | null } | null> } } | { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean } | null } | null } | null> } } | null };

export type UpdateGroupMutationMutationVariables = Exact<{
  groupRowId: Scalars['BigInt']['input'];
  patch: GroupPatch;
}>;


export type UpdateGroupMutationMutation = { __typename?: 'Mutation', updateGroupByRowId?: { __typename?: 'UpdateGroupPayload', group?: { __typename?: 'Group', rowId: string, name: string, avatar?: string | null } | null } | null };

export type AddUsersMutationMutationVariables = Exact<{
  groupRowId: Scalars['BigInt']['input'];
  emails: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type AddUsersMutationMutation = { __typename?: 'Mutation', inviteUsersToGroup?: { __typename?: 'InviteUsersToGroupPayload', group?: { __typename?: 'Group', rowId: string, id: string, createdAt: string, updatedAt: string, label: string, name: string, avatar?: string | null, workflow?: { __typename?: 'Workflow', rowId: string, name: string } | null, members: { __typename?: 'GroupMembersConnection', totalCount: number, nodes: Array<{ __typename?: 'GroupMember', accountId?: string | null, reader?: boolean | null, admin?: boolean | null, account?: { __typename?: 'Account_Account', rowId: number, id: string, entity?: { __typename?: 'Account_Account' } | { __typename?: 'Account_Bot', rowId: number, name: string, avatar?: string | null } | { __typename?: 'Account_IsSuperuser' } | { __typename?: 'Account_Key' } | { __typename?: 'Account_Organization', rowId: number, name: string, avatar?: string | null, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null, user?: { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean } | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number, name: string, avatar?: string | null } | null> } } | { __typename?: 'Account_PrivateKey' } | { __typename?: 'Account_Team', rowId: number, name: string, avatar?: string | null, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null, user?: { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean } | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number, name: string, avatar?: string | null } | null> } } | { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean } | null } | null } | null> } } | null } | null };

export type UpdateGroupMembersMutationMutationVariables = Exact<{
  groupId?: InputMaybe<Scalars['BigInt']['input']>;
  members?: InputMaybe<Array<InputMaybe<UpdateGroupMemberActionInput>> | InputMaybe<UpdateGroupMemberActionInput>>;
}>;


export type UpdateGroupMembersMutationMutation = { __typename?: 'Mutation', updateGroupMembers?: { __typename?: 'UpdateGroupMembersPayload', group?: { __typename?: 'Group', rowId: string, id: string, createdAt: string, updatedAt: string, label: string, name: string, avatar?: string | null, workflow?: { __typename?: 'Workflow', rowId: string, name: string } | null, members: { __typename?: 'GroupMembersConnection', totalCount: number, nodes: Array<{ __typename?: 'GroupMember', accountId?: string | null, reader?: boolean | null, admin?: boolean | null, account?: { __typename?: 'Account_Account', rowId: number, id: string, entity?: { __typename?: 'Account_Account' } | { __typename?: 'Account_Bot', rowId: number, name: string, avatar?: string | null } | { __typename?: 'Account_IsSuperuser' } | { __typename?: 'Account_Key' } | { __typename?: 'Account_Organization', rowId: number, name: string, avatar?: string | null, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null, user?: { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean } | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number, name: string, avatar?: string | null } | null> } } | { __typename?: 'Account_PrivateKey' } | { __typename?: 'Account_Team', rowId: number, name: string, avatar?: string | null, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null, user?: { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean } | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number, name: string, avatar?: string | null } | null> } } | { __typename?: 'Account_User', rowId: number, name: string, avatar?: string | null, email: string, pending?: boolean | null, inviteExpired: boolean } | null } | null } | null> } } | null } | null };

export type MyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileQuery = { __typename?: 'Query', me?: { __typename?: 'Account_User', id: string, rowId: number, name: string, firstName?: string | null, lastName?: string | null, avatar?: string | null, email: string, isSuperuser?: boolean | null, account?: { __typename?: 'Account_Account', id: string, rowId: number, signingKey?: { __typename?: 'Account_Key', rowId: number, publicKey: string, privateKey?: { __typename?: 'Account_PrivateKey', rowId: number, passwordProtected: boolean, decrypted?: string | null } | null } | null } | null, memberOf: { __typename?: 'Account_AccountsConnection', nodes: Array<{ __typename?: 'Account_Account', rowId: number, entity?: { __typename?: 'Account_Account' } | { __typename?: 'Account_Bot' } | { __typename?: 'Account_IsSuperuser' } | { __typename?: 'Account_Key' } | { __typename: 'Account_Organization', rowId: number, name: string, description: string, avatar?: string | null } | { __typename?: 'Account_PrivateKey' } | { __typename?: 'Account_Team', rowId: number, name: string, description: string, avatar?: string | null, organization?: { __typename?: 'Account_Organization', rowId: number, name: string, description: string, avatar?: string | null } | null } | { __typename?: 'Account_User', rowId: number } | null } | null> } } | null };

export type GroupMemberFragment2Fragment = { __typename?: 'GroupMember', accountId?: string | null, reader?: boolean | null, admin?: boolean | null, account?: { __typename?: 'Account_Account', rowId: number, id: string, entity?: { __typename?: 'Account_Account' } | { __typename?: 'Account_Bot', rowId: number } | { __typename?: 'Account_IsSuperuser' } | { __typename?: 'Account_Key' } | { __typename?: 'Account_Organization', rowId: number, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number } | null> }, teams: { __typename?: 'Account_TeamsConnection', nodes: Array<{ __typename?: 'Account_Team', rowId: number } | null> } } | { __typename?: 'Account_PrivateKey' } | { __typename?: 'Account_Team', rowId: number, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number } | null> } } | { __typename?: 'Account_User', rowId: number } | null } | null };

export type WorkflowGroupsFragmentFragment = { __typename?: 'Workflow', rowId: string, id: string, name: string, description?: string | null, canUpdate?: boolean | null, groups: { __typename?: 'GroupsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes: Array<{ __typename?: 'Group', rowId: string, id: string, createdAt: string, updatedAt: string, label: string, name: string, avatar?: string | null, members: { __typename?: 'GroupMembersConnection', totalCount: number, nodes: Array<{ __typename?: 'GroupMember', accountId?: string | null, reader?: boolean | null, admin?: boolean | null, account?: { __typename?: 'Account_Account', rowId: number, id: string, entity?: { __typename?: 'Account_Account' } | { __typename?: 'Account_Bot', rowId: number } | { __typename?: 'Account_IsSuperuser' } | { __typename?: 'Account_Key' } | { __typename?: 'Account_Organization', rowId: number, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number } | null> }, teams: { __typename?: 'Account_TeamsConnection', nodes: Array<{ __typename?: 'Account_Team', rowId: number } | null> } } | { __typename?: 'Account_PrivateKey' } | { __typename?: 'Account_Team', rowId: number, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number } | null> } } | { __typename?: 'Account_User', rowId: number } | null } | null } | null> } } | null> }, nonFilteredGroups: { __typename?: 'GroupsConnection', totalCount: number } };

export type WorkflowGroupsQueryQueryVariables = Exact<{
  workflowRowId: Scalars['BigInt']['input'];
  orderBy?: InputMaybe<Array<GroupsOrderBy> | GroupsOrderBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GroupFilter>;
}>;


export type WorkflowGroupsQueryQuery = { __typename?: 'Query', workflowByRowId?: { __typename?: 'Workflow', rowId: string, id: string, name: string, description?: string | null, canUpdate?: boolean | null, groups: { __typename?: 'GroupsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes: Array<{ __typename?: 'Group', rowId: string, id: string, createdAt: string, updatedAt: string, label: string, name: string, avatar?: string | null, members: { __typename?: 'GroupMembersConnection', totalCount: number, nodes: Array<{ __typename?: 'GroupMember', accountId?: string | null, reader?: boolean | null, admin?: boolean | null, account?: { __typename?: 'Account_Account', rowId: number, id: string, entity?: { __typename?: 'Account_Account' } | { __typename?: 'Account_Bot', rowId: number } | { __typename?: 'Account_IsSuperuser' } | { __typename?: 'Account_Key' } | { __typename?: 'Account_Organization', rowId: number, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number } | null> }, teams: { __typename?: 'Account_TeamsConnection', nodes: Array<{ __typename?: 'Account_Team', rowId: number } | null> } } | { __typename?: 'Account_PrivateKey' } | { __typename?: 'Account_Team', rowId: number, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number } | null> } } | { __typename?: 'Account_User', rowId: number } | null } | null } | null> } } | null> }, nonFilteredGroups: { __typename?: 'GroupsConnection', totalCount: number } } | null };

export type AddGroupMutationMutationVariables = Exact<{
  workflowRowId: Scalars['BigInt']['input'];
  name: Scalars['String']['input'];
  key: Scalars['String']['input'];
  orderBy?: InputMaybe<Array<GroupsOrderBy> | GroupsOrderBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GroupFilter>;
}>;


export type AddGroupMutationMutation = { __typename?: 'Mutation', createGroup?: { __typename?: 'CreateGroupPayload', group?: { __typename?: 'Group', rowId: string } | null, workflow?: { __typename?: 'Workflow', rowId: string, id: string, name: string, description?: string | null, canUpdate?: boolean | null, groups: { __typename?: 'GroupsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes: Array<{ __typename?: 'Group', rowId: string, id: string, createdAt: string, updatedAt: string, label: string, name: string, avatar?: string | null, members: { __typename?: 'GroupMembersConnection', totalCount: number, nodes: Array<{ __typename?: 'GroupMember', accountId?: string | null, reader?: boolean | null, admin?: boolean | null, account?: { __typename?: 'Account_Account', rowId: number, id: string, entity?: { __typename?: 'Account_Account' } | { __typename?: 'Account_Bot', rowId: number } | { __typename?: 'Account_IsSuperuser' } | { __typename?: 'Account_Key' } | { __typename?: 'Account_Organization', rowId: number, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number } | null> }, teams: { __typename?: 'Account_TeamsConnection', nodes: Array<{ __typename?: 'Account_Team', rowId: number } | null> } } | { __typename?: 'Account_PrivateKey' } | { __typename?: 'Account_Team', rowId: number, accountId: number, members: { __typename?: 'Account_MembersConnection', nodes: Array<{ __typename?: 'Account_Member', userId?: number | null } | null> }, bots: { __typename?: 'Account_BotsConnection', nodes: Array<{ __typename?: 'Account_Bot', rowId: number } | null> } } | { __typename?: 'Account_User', rowId: number } | null } | null } | null> } } | null> }, nonFilteredGroups: { __typename?: 'GroupsConnection', totalCount: number } } | null } | null };

export const NewLinkFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NewLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Workflow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"}},{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rawActionByKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionKey"}}}]},{"kind":"Field","name":{"kind":"Name","value":"actionByKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actionKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImporter"}},{"kind":"Field","name":{"kind":"Name","value":"dataEditor"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schema"}},{"kind":"Field","name":{"kind":"Name","value":"uiSchema"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"traces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rowId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"readers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta"}},{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"nextActions"}},{"kind":"Field","name":{"kind":"Name","value":"trace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"head"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkHash"}},{"kind":"Field","name":{"kind":"Name","value":"createdByAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Bot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"info"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewLinkFragmentFragment, unknown>;
export const DashboardUserFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"draft"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"canActQuick"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DashboardUserFragmentFragment, unknown>;
export const UserFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"inviteExpired"}}]}}]} as unknown as DocumentNode<UserFragmentFragment, unknown>;
export const GroupMemberFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupMemberFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"reader"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Bot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"inviteExpired"}}]}}]} as unknown as DocumentNode<GroupMemberFragmentFragment, unknown>;
export const GroupSettingsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMemberFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"inviteExpired"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupMemberFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"reader"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Bot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GroupSettingsFragmentFragment, unknown>;
export const GroupMemberFragment2FragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupMemberFragment2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"reader"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Bot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GroupMemberFragment2Fragment, unknown>;
export const WorkflowGroupsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkflowGroupsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Workflow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"canUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMemberFragment2"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nonFilteredGroups"},"name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupMemberFragment2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"reader"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Bot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<WorkflowGroupsFragmentFragment, unknown>;
export const WorkflowQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkflowQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraceStatesOrderByPath"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TraceStateFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowByRowId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"rowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"canUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"isReader"}},{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"overview"}},{"kind":"Field","name":{"kind":"Name","value":"initState"}},{"kind":"Field","name":{"kind":"Name","value":"initActions"}},{"kind":"Field","name":{"kind":"Name","value":"stateSchema"}},{"kind":"Field","name":{"kind":"Name","value":"actions"}},{"kind":"Field","name":{"kind":"Name","value":"transitions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupedTraceStates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"traceStates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}},{"kind":"Field","name":{"kind":"Name","value":"trace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","alias":{"kind":"Name","value":"canAct"},"name":{"kind":"Name","value":"canActQuick"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]}}]} as unknown as DocumentNode<WorkflowQueryQuery, WorkflowQueryQueryVariables>;
export const TraceByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"traceByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"traceByIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextActions"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TraceByIdsQuery, TraceByIdsQueryVariables>;
export const UpdateWorkflowConfigMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateWorkflowConfigMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newInitState"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newInitActions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newStateSchema"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newActions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newTransitions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newWorkflowConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"config"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"workflowRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowRowId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"initState"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newInitState"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"initActions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newInitActions"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"stateSchema"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newStateSchema"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"actions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newActions"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"transitions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newTransitions"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"overview"}},{"kind":"Field","name":{"kind":"Name","value":"initState"}},{"kind":"Field","name":{"kind":"Name","value":"initActions"}},{"kind":"Field","name":{"kind":"Name","value":"stateSchema"}},{"kind":"Field","name":{"kind":"Name","value":"actions"}},{"kind":"Field","name":{"kind":"Name","value":"transitions"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateWorkflowConfigMutationMutation, UpdateWorkflowConfigMutationMutationVariables>;
export const UserOrganizationTeamsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userOrganizationTeamsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserOrganizationTeamsQueryQuery, UserOrganizationTeamsQueryQueryVariables>;
export const GroupSettingsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"groupSettingsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupByRowId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"rowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupRowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"inviteExpired"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupMemberFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"reader"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Bot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMemberFragment"}}]}}]}}]}}]} as unknown as DocumentNode<GroupSettingsQueryQuery, GroupSettingsQueryQueryVariables>;
export const UpdateGroupMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateGroupMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupPatch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGroupByRowId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupRowId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patch"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateGroupMutationMutation, UpdateGroupMutationMutationVariables>;
export const AddUsersMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addUsersMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emails"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteUsersToGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupRowId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emails"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupSettingsFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"inviteExpired"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupMemberFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"reader"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Bot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMemberFragment"}}]}}]}}]}}]} as unknown as DocumentNode<AddUsersMutationMutation, AddUsersMutationMutationVariables>;
export const UpdateGroupMembersMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateGroupMembersMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"members"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateGroupMemberActionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGroupMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"Variable","name":{"kind":"Name","value":"members"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupSettingsFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"inviteExpired"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupMemberFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"reader"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Bot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMemberFragment"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateGroupMembersMutationMutation, UpdateGroupMembersMutationMutationVariables>;
export const MyProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"myProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isSuperuser"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"signingKey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"publicKey"}},{"kind":"Field","name":{"kind":"Name","value":"privateKey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"passwordProtected"}},{"kind":"Field","name":{"kind":"Name","value":"decrypted"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MyProfileQuery, MyProfileQueryVariables>;
export const WorkflowGroupsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"workflowGroupsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowByRowId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"rowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowRowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowGroupsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupMemberFragment2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"reader"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Bot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkflowGroupsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Workflow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"canUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMemberFragment2"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nonFilteredGroups"},"name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<WorkflowGroupsQueryQuery, WorkflowGroupsQueryQueryVariables>;
export const AddGroupMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addGroupMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"workflowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowRowId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"label"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowGroupsFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupMemberFragment2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"reader"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Bot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account_Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkflowGroupsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Workflow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"canUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMemberFragment2"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nonFilteredGroups"},"name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AddGroupMutationMutation, AddGroupMutationMutationVariables>;